// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./common/images/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./common/images/checkmark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Assistant&family=Roboto:ital,wght@1,100&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Assistant:wght@400;800&family=Roboto:ital,wght@1,100&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Assistant:wght@400;800&family=Roboto:ital,wght@1,100&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Assistant:wght@400;600;700;800&family=Roboto:ital,wght@1,100&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Assistant;
  color: #152745;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

* {
  box-sizing: border-box;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.toastifyclass {
  position: fixed;
  top: 0;
  right: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

::-webkit-scrollbar:vertical {
  width: 7px;
  height: 155px;
  min-height: 20px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:vertical {
  background-clip: padding-box;
  border-radius: 10px;
  background-color: #979797;
  width: 7px;
  height: 155px;
  min-height: 30px;
}

::-webkit-scrollbar:horizontal {
  width: 7px;
  height: 155px;
  min-height: 20px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:horizontal {
  background-clip: padding-box;
  border-radius: 10px;
  background-color: #000000;
  width: 7px;
  height: 155px;
  min-height: 30px;
}

body {
  font-size: 3.2vw;
  overflow-x: hidden;
  align-items: center;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  height: 100% !important;
}

#root {
  display: flex;
  justify-content: center;
  width: 100%;
}

div.app {
  max-width: 441px;
}

div.bankstatement {
  width: 100%;
  position: relative;
  z-index: 0;
  margin-top: 128px;
}
div.bankstatement div.navbar {
  box-shadow: 0px 2px 4px 0px rgba(21, 39, 69, 0.0509803922);
  height: 111px;
}
div.bankstatement div.navbar p {
  position: absolute;
  font-family: Assistant;
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 3%;
  margin-left: 116px;
}
div.bankstatement div.navbar img {
  margin-left: 13%;
}
div.bankstatement div.mybody div.text {
  display: flex;
  gap: 1rem;
  background-color: rgba(21, 39, 69, 0.031372549);
  color: rgba(21, 39, 69, 0.5019607843);
  margin-top: 10%;
  padding: 2%;
  border-radius: 10px;
  width: 360px;
}
div.bankstatement div.mybody div.text img {
  height: 1rem;
  margin-top: 1%;
}
div.bankstatement div.mybody div.text div.some_text p {
  color: rgba(21, 39, 69, 0.5019607843);
  font-weight: 600;
  font-size: 14px;
  margin-top: 0px;
  width: 293px;
}
div.bankstatement div.mybody div.upper_middle {
  margin-top: 1rem;
  position: relative;
  top: 9px;
}
div.bankstatement div.mybody div.upper_middle h1 {
  font-family: Assistant;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}
div.bankstatement div.mybody div.upper_middle button {
  background-color: #16C96F;
  font-family: Assistant;
  font-size: 12px;
  border-radius: 4px 4px 0px 0px;
  width: 105px;
  height: 21px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.04em;
  text-align: center;
  color: #FFFFFF;
  border: none;
  padding: 3px;
  border-radius: 4px, 4px, 0px, 0px;
}
div.bankstatement div.mybody div.slider {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  width: 356px;
}
div.bankstatement div.mybody div.slider .line {
  flex: 1 1;
  border: 1px solid rgba(21, 39, 69, 0.201961);
}
div.bankstatement div.mybody div.slider span {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(21, 39, 69, 0.6);
  margin-inline: 16px;
}
div.bankstatement div.mybody div.middlecontainer {
  box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);
  padding: 18px;
  width: 360px;
  height: 244px;
  border-radius: 10px;
}
div.bankstatement div.mybody div.middlecontainer h1 {
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
}
div.bankstatement div.mybody p {
  font-family: Assistant;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 20px;
  color: rgba(21, 39, 69, 0.6980392157);
}
div.bankstatement div.mybody span {
  font-weight: 600;
  color: rgba(21, 39, 69, 0.6980392157);
}
div.bankstatement div.mybody div.statement {
  display: flex;
  justify-content: space-between;
}
div.bankstatement div.mybody div.statement div.option {
  display: flex;
  background-color: rgba(22, 201, 111, 0.1019607843);
  height: 28px;
  width: 116px;
  padding: 2px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
div.bankstatement div.mybody div.statement div.option p {
  font-weight: 400;
  font-size: 12px;
  margin-top: 17px;
  color: #152745;
}
div.bankstatement div.mybody div.statement div.option span {
  font-weight: 600;
  color: #152745;
  font-size: 12px;
}
div.bankstatement div.mybody div.submitbtn {
  display: flex;
  justify-content: center;
}
div.bankstatement div.mybody div.submitbtn .submit {
  display: flex;
  background-color: #FC6603;
  border: none;
  /* padding: 7px; */
  /* padding-inline: 13px; */
  border-radius: 10px;
  width: 240px;
  height: 60px;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}
div.bankstatement div.mybody div.submitbtn .submit h1 {
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  color: #FFFFFF;
  margin-left: 12px;
}
div.bankstatement div.mybody div.submitbtn .submit img {
  margin-top: -14px;
}
div.bankstatement div.mybody div.upload_container {
  width: 360px;
  margin-top: 1rem;
  box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);
  padding: 5%;
  height: 226px;
  border-radius: 10px;
}
div.bankstatement div.mybody div.upload_container h1 {
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
}
div.bankstatement div.mybody div.upload_container p {
  font-family: Assistant;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  color: rgba(21, 39, 69, 0.6980392157);
  color: rgba(21, 39, 69, 0.6980392157);
}
div.bankstatement div.mybody div.upload_container span {
  font-weight: 600;
  color: rgba(21, 39, 69, 0.6980392157);
}
div.bankstatement div.mybody div.upload_container div.submitbtn button {
  border-radius: 10px;
  border: 1px solid #FC6603;
  background-color: #FFFFFF;
  padding: 4%;
  padding-bottom: 0%;
  width: 240px;
  height: 60px;
}
div.bankstatement div.mybody div.upload_container div.submitbtn button p {
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  color: #FC6603;
  margin-left: 1rem;
  margin-top: -1px;
}
div.bankstatement div.mybody div.footer {
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
}
div.bankstatement div.mybody div.footer img {
  height: 15px;
}
div.bankstatement div.mybody div.footer p {
  margin-top: -1px;
  color: #16C96F;
  margin-left: 2px;
  font-size: 400;
}

body {
  position: relative;
  z-index: 999; /* Ensure the background is on top of other content */
}

div.process {
  position: fixed;
  bottom: 14px;
  z-index: 1200;
  border-radius: 20px;
  margin-left: -14px;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.1019607843);
  padding: 2%;
  width: 389px;
  padding: 33px;
  height: 454px;
}
div.process div.content h1 {
  font-family: Assistant;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
}
div.process div.content p {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
}
div.process div.steps span {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.4);
}
div.process div.steps p {
  margin-bottom: 4px;
}
div.process div.steps p span {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
  margin-left: 4%;
}
div.process div.regulation {
  display: flex;
  margin-top: 3rem;
}
div.process div.regulation img {
  margin-left: 5%;
  height: 2rem;
  margin-top: -6px;
}
div.process div.regulation p {
  font-family: Assistant;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.4);
}
div.process div.proceed {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
div.process div.proceed button {
  border-radius: 10px;
  gap: 10px;
  background-color: #FC6603;
  color: white;
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  border: none;
  padding: 5%;
  padding-inline: 15%;
  width: 240px;
  height: 60px;
}

div.verifyotp {
  height: auto;
  width: 100%;
  position: relative;
  z-index: 0;
  top: 40px;
}
div.verifyotp div.navbar {
  box-shadow: 0px 2px 4px 0px rgba(21, 39, 69, 0.0509803922);
  height: 106px;
}
div.verifyotp div.navbar p {
  position: absolute;
  font-family: Assistant;
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 82px;
  margin-top: 12px;
}
div.verifyotp div.navbar img {
  margin-left: 10%;
}
div.verifyotp div.mybody {
  padding-inline: 10%;
  margin-top: 127px;
}
div.verifyotp div.mybody div.bank {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}
div.verifyotp div.mybody div.otppanel {
  text-align: center;
  margin-top: 23px;
}
div.verifyotp div.mybody div.otppanel div.inp p {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
}
div.verifyotp div.mybody div.otppanel div.inp input {
  width: 51.3px !important;
  height: 53px;
  border-radius: 2.5px;
  border-radius: 2.5px;
  margin-left: 5px;
  border: 0.63px solid rgba(21, 39, 69, 0.3019607843);
  padding: 3%;
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  outline: none;
  margin-top: 5px;
}
div.verifyotp div.mybody div.otppanel div.inp input[type=number]:focus {
  outline: none;
  border: 0.63px solid #FC6603 !important;
}
div.verifyotp div.mybody div.otppanel div.inp .active {
  border: 0.63px solid #FC6603;
}
div.verifyotp div.mybody div.otppanel div.inp div.resend {
  display: flex;
  justify-content: space-between;
  margin-top: 43px;
  justify-content: center;
  gap: 205px;
}
div.verifyotp div.mybody div.otppanel div.inp div.resend .re {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  color: rgba(21, 39, 69, 0.5019607843);
  text-decoration: underline;
}
div.verifyotp div.mybody div.otppanel div.inp div.resend .resend {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  color: rgba(21, 39, 69, 0.5019607843);
  text-decoration: underline;
  color: #FC6603;
}
div.verifyotp div.mybody div.otppanel div.inp div.resend .resend:hover {
  cursor: pointer;
}
div.verifyotp div.mybody div.otppanel div.inp div.resend .time {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  color: #152745;
}
div.verifyotp div.mybody div.otppanel .warning {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 23px;
}
div.verifyotp div.mybody div.otppanel .warning span {
  font-weight: 600;
}
div.verifyotp div.mybody div.otppanel button {
  margin-top: 20px;
  padding: 20px, 25px, 20px, 25px;
  border-radius: 10px;
  gap: 10px;
  background-color: #FC6603;
  color: #FFFFFF;
  border: none;
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  width: 240px;
  height: 60px;
}
div.verifyotp div.mybody div.otppanel button:disabled {
  background-color: rgba(252, 102, 3, 0.4);
}
div.verifyotp div.mybody div.otppanel .terms {
  margin-top: 3rem;
  background: #FFFFFF;
  font-family: Assistant;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
}
div.verifyotp div.mybody div.otppanel .terms span {
  color: #FC6603;
  text-decoration: underline;
  font-weight: 600;
}
div.verifyotp div.mybody div.otppanel .terms span:hover {
  cursor: pointer;
}
div.verifyotp div.mybody div.otppanel .finvu {
  margin-top: 32px;
  font-family: Assistant;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: #152745;
}
div.verifyotp div.mybody div.footer {
  margin-top: 6rem;
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
}
div.verifyotp div.mybody div.footer p {
  margin-left: 4px;
  margin-top: -1px;
  font-family: Assistant;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: #16C96F;
}
div.verifyotp div.mybody div.footer img {
  height: 17px;
}

div.navbarcomponent {
  padding: 45px;
  position: absolute;
  top: 0;
  left: 0px;
  width: 100vw;
  height: 114px;
  display: flex;
  justify-content: center;
  gap: 25px;
}
div.navbarcomponent h1 {
  display: inline;
  font-family: Assistant;
  font-size: 28px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
  position: absolute;
  left: 19%;
}
div.navbarcomponent img {
  height: 16px;
  width: 10px;
  margin-top: 8px;
  position: absolute;
  left: 8%;
}
div.navbarcomponent img:hover {
  cursor: pointer;
}

div.jointlogo {
  display: flex;
  justify-content: center;
  gap: 135px;
  position: relative;
  top: 135px;
}
div.jointlogo img {
  width: min(20vw, 97px);
  width: 98px;
  height: 48px;
}

div.selectbank {
  position: relative;
  top: 10;
  padding-inline: 21px;
  top: 168px;
  min-height: 500px;
}
div.selectbank div.input input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 6%;
  padding: 3%;
  padding-inline: 16%;
  border: 1px solid rgba(21, 39, 69, 0.2);
  outline: none;
  width: 360px;
  height: min(15vw, 64px);
  border-radius: 10px;
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.4);
  box-sizing: border-box;
  text-decoration: none;
}
div.selectbank div.input input::placeholder {
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.4);
  text-decoration: none;
}
div.selectbank div.allbanks {
  max-width: 360px !important;
}
div.selectbank div.allbanks div.othersbank {
  margin-top: 2rem;
}
div.selectbank div.allbanks div.othersbank h1 {
  font-family: Assistant;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
}
div.selectbank div.allbanks div.othersbank h1 img {
  margin-left: 3px;
  margin-top: -3px;
}
div.selectbank div.allbanks div.othersbank h1:hover {
  cursor: pointer;
}
div.selectbank div.allbanks div.othersbank .active {
  color: #FC6603;
}
div.selectbank div.allbanks div.othersbank div.banks {
  margin-top: 19px;
}
div.selectbank div.allbanks div.othersbank div.banks hr {
  border: 1px solid rgba(21, 39, 69, 0.0705882353);
  width: 362px;
}
div.selectbank div.allbanks div.othersbank div.banks div.mybank {
  display: flex;
  margin-top: 10px;
}
div.selectbank div.allbanks div.othersbank div.banks div.mybank img {
  height: 41px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2509803922);
  border-radius: 50% 50%;
  padding: 9px;
  width: 41px;
}
div.selectbank div.allbanks div.othersbank div.banks div.mybank span {
  margin-left: 4%;
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
  margin-top: 8px;
}
div.selectbank div.allbanks div.othersbank div.banks:hover {
  cursor: pointer;
}
div.selectbank div.allbanks div.Banks {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 7%;
}
div.selectbank div.allbanks div.Banks div.singlebank:hover {
  cursor: pointer;
}
div.selectbank div.allbanks div.Banks div.singlebank {
  width: 101px;
  border: 1px solid black;
  padding: 0%;
  text-align: center;
  margin-top: 6%;
  border: 0.5px solid #FC6603;
  border-radius: 5px;
  height: 103px;
}
div.selectbank div.allbanks div.Banks div.singlebank img {
  margin-top: 5px;
  height: 41px;
  width: 47px;
}
div.selectbank div.allbanks div.Banks div.singlebank p {
  font-family: Assistant;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 14px;
  color: rgba(21, 39, 69, 0.6);
}
div.selectbank div.footer2 {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  bottom: -57px;
}

div.footer {
  position: relative;
  bottom: 0px;
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
}
div.footer p {
  margin-left: 4px;
  margin-top: -1px;
  font-family: Assistant;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: #16C96F;
}
div.footer img {
  height: 1rem;
}

div.linkaccount {
  padding-inline: 9%;
  position: relative;
  z-index: 0;
  top: 129px;
  margin-top: 152px;
}
div.linkaccount div.content {
  margin-top: -106px;
}
div.linkaccount div.content p {
  font-family: Assistant;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}
div.linkaccount div.content div.bank_account {
  margin-top: 44px;
}
div.linkaccount div.content div.bank_account div.bank {
  display: flex;
  margin-top: 6%;
  border: 1px solid rgba(21, 39, 69, 0.3019607843);
  border-radius: 10px;
  padding: 2%;
  width: 366px;
}
div.linkaccount div.content div.bank_account div.bank img {
  height: 30px;
  width: 30px;
  margin-top: 11px;
  margin-left: 4px;
}
div.linkaccount div.content div.bank_account div.bank input {
  margin-left: 29px;
  width: 25px;
  height: 25px;
  border: 1px solid rgba(21, 39, 69, 0.3019607843);
  margin-top: 19px;
  -webkit-appearance: none;
  color: white;
}
div.linkaccount div.content div.bank_account div.bank input[type=checkbox]:checked::before {
  background-color: #16C96F;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  color: white;
  display: block;
  font-size: 26px;
  text-align: center;
  line-height: 20px;
  height: 27px;
  width: 27px;
  margin-left: -1px;
  margin-top: -2px;
}
div.linkaccount div.content div.bank_account div.bank .checkedinput {
  margin-left: 27px;
}
div.linkaccount div.content div.bank_account div.bank div.information {
  margin-left: 10%;
}
div.linkaccount div.content div.bank_account div.bank div.information p {
  margin-bottom: 0px;
}
div.linkaccount div.content div.bank_account div.bank div.information .name {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.6);
  width: 223px;
}
div.linkaccount div.content div.bank_account div.bank div.information .account {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
}
div.linkaccount div.content div.bank_account div.bank div.information .type {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #FC6603;
}
div.linkaccount .go_to_linked_accounts {
  margin-top: 16px;
  font-family: Assistant;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #FC6603;
  text-decoration: underline;
  text-decoration-skip-ink: auto;
}
div.linkaccount .go_to_linked_accounts:hover {
  cursor: pointer;
}
div.linkaccount div.submitbtn {
  margin-top: 3rem;
  display: flex;
  justify-content: center;
}
div.linkaccount div.submitbtn button {
  width: 70%;
  height: 10%;
  padding: 20px 25px 20px 25px;
  border-radius: 10px;
  gap: 10px;
  background-color: #FC6603;
  font-family: Assistant;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
  outline: none;
  border: none;
}
div.linkaccount div.submitbtn button:disabled {
  background-color: rgba(252, 102, 3, 0.4);
}

div.otpcontainer {
  position: fixed;
  width: 100vw;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.2);
  bottom: 0px;
  left: 0;
  align-items: center;
  /* text-align: center; */
  display: flex;
  justify-content: center;
}
div.otpcontainer div.otp {
  position: absolute;
  bottom: 8px;
  background-color: white;
  padding: min(8%, 35px);
  width: min(420px, 93%);
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.1019607843);
  border-radius: 20px;
}
div.otpcontainer div.otp div.inp p {
  font-family: Assistant;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
}
div.otpcontainer div.otp div.inp p span {
  font-family: Assistant;
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
}
div.otpcontainer div.otp div.inp h1 {
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}
div.otpcontainer div.otp div.inp input {
  width: 51px !important;
  height: 51px !important;
  border-radius: 2.5px;
  border-radius: 2.5px;
  margin-left: 3px;
  border: 0.63px solid rgba(21, 39, 69, 0.3019607843);
  padding: 1%;
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  outline: none;
  margin-top: 9px;
}
div.otpcontainer div.otp div.inp input[type=number]:focus {
  outline: none;
  border: 1px solid #FC6603 !important;
}
div.otpcontainer div.otp div.inp .active {
  border: 1px solid #FC6603;
}
div.otpcontainer div.otp div.inp div.resend {
  text-align: center;
  margin-top: 7%;
}
div.otpcontainer div.otp div.inp div.resend button:disabled {
  background-color: rgba(252, 102, 3, 0.4);
}
div.otpcontainer div.otp div.inp div.resend button {
  width: 60%;
  height: 5vh;
  margin-top: 1.8rem;
  width: 240px;
  height: 60px;
  padding: 20px, 25px, 20px, 25px;
  border-radius: 10px;
  gap: 10px;
  background-color: #FC6603;
  color: #FFFFFF;
  border: none;
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
}
div.otpcontainer div.otp div.inp div.resend p .didnotreceive {
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: center;
  color: #152745;
}
div.otpcontainer div.otp div.inp div.resend p .receive {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: center;
  text-decoration: underline;
  color: #9AA2AF;
}
div.otpcontainer div.otp div.inp div.resend p .receive2 {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: center;
  color: #FC6603;
  text-decoration: underline;
}
div.otpcontainer div.otp div.inp div.resend p .receive2:hover {
  cursor: pointer;
}

div.confirmconsent .consentDetail {
  margin-top: 150px;
  padding: 3%;
}
div.confirmconsent .consentDetail h1 {
  font-family: Assistant;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 9px;
  margin-left: 4px;
}
div.confirmconsent .consentDetail .consentform {
  margin-top: 7%;
}
div.confirmconsent .consentDetail .consentform .date {
  display: flex;
  justify-content: space-between;
}
div.confirmconsent .consentDetail .consentform .addaccount {
  margin-top: 18px;
}
div.confirmconsent .consentDetail .consentform .addaccount .plus {
  margin-top: 5%;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #FC6603;
  text-decoration: none;
}
div.confirmconsent .consentDetail .consentform .addaccount .addacn {
  margin-top: 5%;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #FC6603;
  text-decoration: underline;
  margin-left: 6px;
}
div.confirmconsent .consentDetail .consentform .addaccount:hover {
  cursor: pointer;
}
div.confirmconsent .consentDetail .consentform div.submit {
  margin-top: 15%;
  text-align: center;
}
div.confirmconsent .consentDetail .consentform div.submit button {
  border: none;
  width: 240px;
  height: 60px;
  background-color: #FC6603;
  border-radius: 10px;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  color: #FFFFFF;
}
div.confirmconsent .consentDetail .consentform div.submit button:disabled {
  background-color: rgba(252, 102, 3, 0.4);
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank {
  display: flex;
  margin-top: 7%;
  border: 1px solid rgba(21, 39, 69, 0.3019607843);
  border-radius: 10px;
  padding: 2%;
  width: 360px;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank input {
  margin-left: 147px;
  width: 25px;
  height: 25px;
  border: 1px solid rgba(21, 39, 69, 0.3019607843);
  margin-top: 19px;
  -webkit-appearance: none;
  color: white;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank img {
  width: 36px;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank input[type=checkbox]:checked::before {
  background-color: #16C96F;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  color: white;
  display: block;
  font-size: 26px;
  text-align: center;
  line-height: 20px;
  height: 27px;
  width: 27px;
  margin-left: -1px;
  margin-top: -2px;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information {
  margin-left: 10%;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information p {
  margin-bottom: 0px;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .name {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.6);
  max-width: 88px;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .account {
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #152745;
}
div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .type {
  font-family: Assistant;
  font-size: 1rem;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #FC6603;
}
div.confirmconsent .consentDetail .consentform .field {
  font-family: Assistant;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.8);
}
div.confirmconsent .consentDetail .consentform .value {
  font-family: Assistant;
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(21, 39, 69, 0.6);
}

div.finalresults div.logo {
  margin-top: -81px;
}
div.finalresults div.content {
  margin-top: 182px;
  text-align: center;
}
div.finalresults div.content h1 {
  margin-top: 20%;
  font-size: 2rem;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0em;
}
div.finalresults div.content p {
  margin-top: 10%;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
}
div.finalresults div.content p .wait {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
}
div.finalresults .myybtn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 94px;
}
div.finalresults .myybtn button {
  width: 240px;
  height: 60px;
  padding: 20px, 25px, 20px, 25px;
  border-radius: 10px;
  border: 1px solid #FC6603;
  font-family: Assistant;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  outline: none;
  background-color: #FFFFFF;
  color: #FC6603;
}

@media screen and (max-width: 680px) {
  body {
    overflow-x: hidden;
  }
}
@media screen and (max-width: 427px) {
  div.verifyotp div.mybody div.otppanel div.inp input {
    width: 46.3px;
    height: 46.7px;
  }
}
@media screen and (max-width: 439px) {
  div.otp div.inp input {
    width: 50px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 423px) {
  div.otpcontainer div.otp div.inp input {
    width: 48px !important;
    height: 48px !important;
  }
}
@media screen and (max-width: 415px) {
  div.verifyotp div.mybody div.otppanel div.inp input {
    width: 12vw !important;
    height: 12.6vw !important;
  }
  div.linkaccount div.content div.bank_account div.bank {
    display: flex;
    margin-top: 6%;
    border: 1px solid rgba(21, 39, 69, 0.3019607843);
    border-radius: 10px;
    padding: 2%;
    width: 363px;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 101px !important;
  }
  div.selectbank div.allbanks div.othersbank div.banks hr {
    width: 346px !important;
  }
}
@media screen and (max-width: 410px) {
  div.verifyotp div.mybody div.otppanel div.inp div.resend {
    display: flex;
    justify-content: space-between;
    margin-top: 43px;
    justify-content: center;
    gap: 178px;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 98px !important;
  }
  div.otpcontainer div.otp div.inp input {
    width: 47px !important;
    height: 48px !important;
  }
}
@media screen and (max-width: 400px) {
  body {
    min-width: 300px;
  }
  div.bankstatement div.navbar p {
    font-family: Assistant;
    font-size: 27px;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 3%;
    margin-right: min(4vw, 80px);
  }
  div.bankstatement div.mybody div.upload_container p {
    font-family: Assistant;
    font-size: 12px !important;
  }
  div.bankstatement div.mybody div.statement div.option p {
    font-size: 0.5rem;
    margin-left: 5px;
  }
  div.process div.regulation p {
    font-size: 2.72vw;
  }
  div.process div.steps p span {
    font-size: 0.6rem;
  }
  div.process div.content p {
    font-size: 0.7rem;
  }
  div.otppanel div.inp input {
    width: 9vw !important;
  }
  div.otppanel div.inp div.resend .re {
    font-size: 4vw !important;
  }
  div.otppanel div.inp div.resend .time {
    font-size: 5vw !important;
  }
  div.otppanel .warning {
    font-size: 5vw !important;
  }
  div.otppanel .terms {
    font-size: 4vw !important;
  }
  div.verifyotp div.mybody div.otppanel {
    width: 78vw !important;
  }
  div.verifyotp div.mybody div.otppanel .finvu {
    font-size: 3.5vw !important;
  }
  div.verifyotp div.bank img {
    height: 28px !important;
    margin-top: 11px;
  }
  div.verifyotp div.bank .finvologo {
    height: 42px !important;
    margin-top: 0px;
  }
  div.selectbank div.input div.othersbank div.banks span {
    font-size: 5vw !important;
  }
  div.verifyotp div.mybody div.otppanel button {
    width: 60vw !important;
  }
  div.selectbank div.input div.Banks div.singlebank {
    width: 25vw !important;
    height: 97px !important;
  }
  div.selectbank div.input div.Banks div.singlebank p {
    font-size: 11px !important;
  }
  div.verifyotp div.mybody div.footer {
    font-size: 4vw !important;
  }
  div.confirmconsent .consentDetail {
    margin-left: 1% !important;
  }
  div.confirmconsent .consentDetail h1 {
    font-family: Assistant;
    font-size: 1.2rem !important;
  }
  div.confirmconsent .consentDetail .consentform .field {
    font-family: Assistant;
    font-size: 18px !important;
  }
  div.confirmconsent .consentDetail .consentform .value {
    font-family: Assistant;
    font-size: 16px !important;
  }
  div.selectbank div.input input {
    height: 58px !important;
    width: 85vw !important;
  }
  div.confirmconsent .consentDetail .consentform .date {
    display: flex !important;
    gap: 25vw !important;
    justify-content: left;
  }
  div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .name {
    font-family: Assistant;
    font-size: 16px !important;
    max-width: 89px;
  }
  div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .account {
    font-family: Assistant;
    font-size: 18px !important;
  }
  div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .type {
    font-family: Assistant;
    font-size: 16px !important;
  }
  div.verifyotp div.navbar {
    width: 100vw !important;
  }
  div.confirmconsent .consentDetail .consentform div.bank_account div.bank {
    width: 83vw !important;
  }
  div.verifyotp div.navbar p {
    font-family: Assistant;
    font-size: 8vw;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
    margin-right: 29%;
    margin-top: 11px;
  }
  div.bankstatement div.mybody div.upload_container div.submitbtn button p {
    font-family: Assistant;
    font-size: 13px !important;
  }
  div.bankstatement div.mybody div.upload_container div.submitbtn button img {
    height: 23px;
  }
  div.linkaccount div.content div.bank_account div.bank div.information .name {
    font-family: Assistant;
    font-size: 16px !important;
    width: 51vw;
  }
  div.linkaccount div.content div.bank_account div.bank div.information .account {
    font-family: Assistant;
  }
  div.linkaccount div.content div.bank_account div.bank div.information .type {
    font-family: Assistant;
    font-size: 15px !important;
  }
  div.linkaccount div.content div.bank_account div.bank input {
    margin-left: 8vw !important;
  }
  div.navbarcomponent {
    width: 100vw;
  }
  div.linkaccount div.content div.bank_account div.bank {
    width: 87vw !important;
  }
  div.otp div.inp div.resend button {
    width: 59vw !important;
  }
  div.verifyotp div.mybody div.otppanel div.inp p {
    font-family: Assistant;
    font-size: 14px !important;
  }
  div.bankstatement div.mybody div.text {
    display: flex;
    gap: 16px;
    background-color: rgba(21, 39, 69, 0.031372549);
    color: rgba(21, 39, 69, 0.5019607843);
    margin-top: 10%;
    padding: 2%;
    border-radius: 10px;
    width: 285px;
    align-content: center;
  }
  div.bankstatement div.mybody div.text div.some_text p {
    color: rgba(21, 39, 69, 0.5019607843);
    font-weight: 600;
    font-size: 11px;
    margin-top: 0px;
    width: 228px;
  }
  div.bankstatement div.mybody div.middlecontainer {
    box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);
    padding: 18px;
    width: 285px;
    height: 240px;
    border-radius: 10px;
  }
  div.bankstatement div.mybody div.upload_container {
    width: 285px;
    margin-top: 1rem;
    box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);
    padding: 5%;
    height: 232px;
    border-radius: 10px;
  }
  div.bankstatement div.mybody div.upload_container div.submitbtn button p {
    font-family: Assistant;
    font-size: 17px !important;
  }
  div.bankstatement div.mybody div.statement div.option p {
    font-size: 10px;
    margin-left: 7px;
  }
  div.bankstatement div.mybody div.statement div.option span {
    font-weight: 600;
    color: #152745;
    font-size: 0.7rem;
  }
  div.bankstatement div.mybody div.slider {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    width: 285px;
  }
  div.process {
    border-radius: 20px;
    width: 87vw;
    padding: 25px;
    height: 455px;
    margin-left: -6vw;
  }
  div.process div.content p {
    font-size: 12px;
  }
  div.process div.steps p span {
    font-size: 12px;
  }
  div.process div.proceed button {
    border-radius: 10px;
    gap: 10px;
    background-color: #FC6603;
    color: white;
    font-family: Assistant;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    border: none;
    padding: 5%;
    padding-inline: 15%;
    width: 193px;
    height: 54px;
  }
  div.verifyotp div.mybody div.otppanel div.inp div.resend {
    display: flex;
    justify-content: space-between;
    margin-top: 43px;
    justify-content: center;
    gap: 116px;
  }
  div.verifyotp div.mybody div.footer p {
    font-size: 11px !important;
  }
  div.footer p {
    font-size: 11px !important;
  }
  div.verifyotp div.mybody {
    padding-inline: 0% !important;
  }
  div.otp div.inp input {
    width: 34px !important;
    height: 51px !important;
  }
  div.linkaccount div.content div.bank_account div.bank .checkedinput {
    margin-left: 8vw !important;
  }
}
.underreviewresults {
  padding-inline: 16px;
}
.underreviewresults .loadingimages {
  text-align: center;
}
.underreviewresults .loadingimages img {
  height: 345px;
  margin-top: 15px;
  width: 343px;
}
.underreviewresults .loadingimages .review-text {
  color: #152745;
  font-family: Assistant;
  font-size: 40px;
  font-weight: 700;
  line-height: 52.32px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-top: 36px;
}
.underreviewresults .loadingimages .review-message {
  font-family: Assistant;
  font-size: 18px;
  font-weight: 400;
  line-height: 23.54px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.underreviewresults .loadingimages button {
  width: 240px;
  height: 60px;
  gap: 10px;
  border-radius: 10px;
  opacity: 0px;
  border: none;
  background-color: #FC6603;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 600;
  margin-top: 200px;
  position: relative;
  bottom: 40px;
}

@media screen and (max-width: 400px) {
  div.otp div.inp input {
    width: 37px !important;
    height: 49px !important;
  }
  div.confirmconsent .consentDetail .consentform div.bank_account div.bank input {
    margin-left: 30vw !important;
  }
  div.confirmconsent .consentDetail .consentform div.submit button {
    border: none;
    width: 260px;
    height: 60px;
    background-color: #FC6603;
    border-radius: 10px;
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    color: #FFFFFF;
  }
  div.jointlogo {
    gap: 64px !important;
  }
  div.otpcontainer div.otp div.inp input {
    width: 12vw !important;
    height: 12vw !important;
  }
  div.verifyotp div.mybody div.otppanel div.inp input {
    width: 11vw !important;
    height: 11.6vw !important;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24vw !important;
    height: 98px !important;
  }
  div.selectbank div.allbanks div.othersbank div.banks hr {
    width: 84vw !important;
  }
  div.selectbank div.allbanks div.Banks div.singlebank p {
    font-size: 13px !important;
  }
  div.selectbank div.allbanks {
    max-width: 335px !important;
  }
}
@media screen and (max-width: 387px) {
  div.otp div.inp p {
    font-family: Assistant;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24.2vw !important;
    height: 97px !important;
  }
}
@media screen and (max-width: 390px) {
  div.selectbank div.allbanks {
    max-width: 327px !important;
  }
}
@media screen and (max-width: 383px) {
  div.selectbank div.allbanks div.Banks {
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    gap: 4%;
  }
  div.selectbank div.input input {
    height: 58px !important;
    width: 80vw !important;
  }
  div.selectbank div.allbanks {
    max-width: 311px !important;
  }
}
@media screen and (max-width: 375px) {
  div.otp div.inp p {
    font-family: Assistant;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
  }
  div.selectbank div.allbanks {
    max-width: 300px !important;
  }
  div.selectbank div.allbanks div.Banks {
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    gap: 3%;
  }
}
@media screen and (max-width: 361px) {
  div.confirmconsent .consentDetail .consentform div.bank_account div.bank input {
    margin-left: 25vw !important;
  }
  div.otp div.inp input {
    width: 10vw !important;
    height: 44px !important;
  }
  div.otpcontainer div.otp div.inp input {
    width: 11vw !important;
    height: 11vw !important;
  }
}
@media screen and (max-width: 374px) {
  div.verifyotp div.mybody div.otppanel div.inp input {
    width: 37px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 374px) {
  div.verifyotp div.mybody div.otppanel div.inp input {
    width: 11.5vw !important;
    height: 12.6vw !important;
  }
  div.linkaccount div.content div.bank_account div.bank div.information .name {
    font-family: Assistant;
    font-size: 16px !important;
    width: 45vw !important;
  }
}
@media screen and (max-width: 375px) {
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24.6vw !important;
    height: 100px !important;
  }
}
@media screen and (max-width: 365px) {
  div.process {
    border-radius: 20px;
    width: 87vw;
    padding: 25px;
    height: 455px;
    margin-left: -4vw;
  }
}
@media screen and (max-width: 362px) {
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24.6vw !important;
    height: 101px !important;
  }
}
@media screen and (max-width: 355px) {
  div.linkaccount div.content div.bank_account div.bank .checkedinput {
    margin-left: 8vw !important;
  }
  div.linkaccount div.content div.bank_account div.bank {
    width: 84vw !important;
  }
  div.linkaccount div.content div.bank_account div.bank div.information .name {
    font-family: Assistant;
    font-size: 16px !important;
    width: 49vw;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24vw !important;
    height: 101px !important;
  }
  div.selectbank div.allbanks div.Banks div.singlebank p {
    font-size: 12px !important;
  }
  div.selectbank div.allbanks {
    max-width: 282px !important;
  }
}
@media screen and (max-width: 346px) {
  div.linkaccount div.content div.bank_account div.bank div.information .name {
    font-family: Assistant;
    font-size: 15px !important;
  }
  div.jointlogo {
    gap: 20vw !important;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24vw !important;
    height: 101px !important;
  }
  div.selectbank div.input input {
    height: 58px !important;
    width: 81vw !important;
  }
  div.verifyotp div.mybody div.otppanel div.inp div.resend {
    gap: 94px !important;
  }
}
@media screen and (max-width: 342px) {
  div.process {
    border-radius: 20px;
    width: 87vw;
    padding: 25px;
    height: 455px;
    margin-left: -1vw;
  }
  div.selectbank div.allbanks {
    max-width: 265px !important;
  }
}
@media screen and (max-width: 332px) {
  div.linkaccount div.content div.bank_account div.bank div.information .name {
    font-family: Assistant;
  }
  div.selectbank div.allbanks div.Banks div.singlebank {
    width: 24vw !important;
    height: 96px !important;
  }
  div.selectbank div.allbanks div.Banks div.singlebank p {
    margin-top: 5px !important;
  }
}
@media screen and (max-width: 324px) {
  div.process {
    margin-left: 1vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AAMA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;AADA;;AAGA;EAGI,sBAAA;AAAJ;;AAEA;;EAEE,wBAAA;EACA,SAAA;AACF;;AACA;EACG,eAAA;EACC,MAAA;EACA,QAAA;AAEJ;;AAAA,YAAA;AACA;EACE,0BAAA;AAGF;;AAAA;EACI,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAGJ;;AAAE;EACE,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;AAGJ;;AAAE;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAGJ;;AAAE;EAEE,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;AAEJ;;AAGA;EACI,gBAAA;EAEA,kBAAA;EAGH,mBAAA;EACA,WAAA;EACG,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AAHJ;;AAeA;EAEI,aAAA;EACA,uBAAA;EACA,WAAA;AAbJ;;AAmBA;EACI,gBAAA;AAhBJ;;AAmBA;EAEI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAjBJ;AAkBI;EACI,0DAAA;EACA,aAAA;AAhBR;AAiBQ;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAfZ;AAkBQ;EACI,gBAAA;AAhBZ;AAsBI;EACI,aAAA;EACC,SAAA;EACD,+CAAA;EACA,qCAAA;EACA,eAAA;EACA,WAAA;EACP,mBAAA;EAEG,YAAA;AArBJ;AAsBM;EACE,YAAA;EACA,cAAA;AApBR;AAuBQ;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AArBR;AA0BI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;AAxBR;AAyBQ;EACA,sBAAA;EACA,eAAA;EACR,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAvBA;AAyBQ;EACI,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACZ,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,iCAAA;AAvBA;AA2BA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAzBJ;AA0BG;EACC,SAAA;EACD,4CAAA;AAxBH;AA0BG;EACC,sBAAA;EACJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AAxBA;AA8BI;EACI,iDAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA5BR;AA6BQ;EACI,sBAAA;EACA,eAAA;EACZ,gBAAA;EACA,iBAAA;EACA,mBAAA;AA3BA;AAgCI;EAGI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;AAhCR;AAmCI;EACI,gBAAA;EACA,qCAAA;AAjCR;AAqCI;EACI,aAAA;EACA,8BAAA;AAnCR;AAoCQ;EACI,aAAA;EACA,kDAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAlCZ;AAoCA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlCJ;AAoCA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AAlCJ;AAuCI;EACI,aAAA;EACA,uBAAA;AArCR;AAsCQ;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AApCZ;AAqCQ;EACI,sBAAA;EACZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAnCA;AAsCQ;EACI,iBAAA;AApCZ;AAyCI;EACI,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAvCR;AAyCQ;EACI,sBAAA;EACA,eAAA;EACZ,gBAAA;EACA,iBAAA;EACA,mBAAA;AAvCA;AA0CQ;EAGR,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,qCAAA;AA1CA;AA+CQ;EACI,gBAAA;EACA,qCAAA;AA7CZ;AAkDY;EAEI,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAjDhB;AAmDA;EACI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAjDJ;AA0DI;EACG,gBAAA;EACC,aAAA;EACA,uBAAA;EAEA,kBAAA;AAzDR;AA0DQ;EACI,YAAA;AAxDZ;AA2DQ;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAzDZ;;AA+DA;EACI,kBAAA;EAGA,YAAA,EAAA,qDAAA;AA9DJ;;AAiEA;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EAGA,wDAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AAhEJ;AAkEQ;EACI,sBAAA;EACZ,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAhEA;AAmEQ;EACI,sBAAA;EACZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAjEA;AAuEQ;EACA,sBAAA;EACR,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AArEA;AAyEQ;EACI,kBAAA;AAvEZ;AAwEY;EACA,sBAAA;EACZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAtEA;AA4EI;EACI,aAAA;EAEA,gBAAA;AA3ER;AA4EQ;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AA1EZ;AA4EQ;EACI,sBAAA;EACA,eAAA;EACZ,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AA1EA;AA8EI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AA5ER;AA6EQ;EACI,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AA3EZ;;AAkFA;EACI,YAAA;EACA,WAAA;EAEJ,kBAAA;EACA,UAAA;EACA,SAAA;AAhFA;AAiFI;EACI,0DAAA;EACA,aAAA;AA/ER;AAgFQ;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AA9EZ;AAiFQ;EACI,gBAAA;AA/EZ;AAkFI;EACI,mBAAA;EACA,iBAAA;AAhFR;AAiFI;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AA/ER;AAkFI;EACI,kBAAA;EACA,gBAAA;AAhFR;AAkFY;EACI,sBAAA;EACA,eAAA;EAChB,gBAAA;EACA,iBAAA;EACA,mBAAA;AAhFA;AAmFY;EACI,wBAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mDAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAjFhB;AAmFY;EACI,aAAA;EACA,uCAAA;AAjFhB;AAmFY;EACI,4BAAA;AAjFhB;AAoFY;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;AAlFhB;AAqFA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,0BAAA;AAnFA;AAqFA;EACI,sBAAA;EACJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,0BAAA;EACI,cAAA;AAnFJ;AAqFA;EAEI,eAAA;AApFJ;AAuFgB;EACI,sBAAA;EACpB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AArFA;AA4FA;EACI,sBAAA;EACA,eAAA;EACJ,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA1FA;AA2FA;EACI,gBAAA;AAzFJ;AA8FA;EACI,gBAAA;EAEJ,+BAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,YAAA;EACA,YAAA;AA/FA;AAiGA;EACI,wCAAA;AA/FJ;AAkGA;EACI,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EAEA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAjGJ;AAkGG;EACD,cAAA;EACA,0BAAA;EACA,gBAAA;AAhGF;AAmGG;EACD,eAAA;AAjGF;AAoGA;EACI,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAlGJ;AAwGI;EACI,gBAAA;EACC,aAAA;EACA,uBAAA;EAEA,kBAAA;AAvGT;AAwGS;EACG,gBAAA;EACA,gBAAA;EACA,sBAAA;EACZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAtGA;AAwGS;EACG,YAAA;AAtGZ;;AA2GA;EAGI,aAAA;EACA,kBAAA;EACA,MAAA;EAEA,SAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AA3GJ;AA6GI;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AA3GR;AA6GI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AA3GR;AA6GI;EACI,eAAA;AA3GR;;AA+GA;EACI,aAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AA5GJ;AA6GI;EACI,sBAAA;EACA,WAAA;EACA,YAAA;AA3GR;;AA8GA;EAEI,kBAAA;EACA,OAAA;EACA,oBAAA;EACA,UAAA;EAiJJ,iBAAA;AA5PA;AAiHQ;EACI,yDAAA;EACA,4BAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACZ,uCAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EAEA,qBAAA;AAhHA;AAmHQ;EACI,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AAjHZ;AAoHI;EACI,2BAAA;AAlHR;AAmHA;EACI,gBAAA;AAjHJ;AAkHI;EACI,sBAAA;EACR,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAhHA;AAkHA;EACI,gBAAA;EACA,gBAAA;AAhHJ;AAmHI;EACI,eAAA;AAjHR;AAmHG;EACK,cAAA;AAjHR;AAoHI;EACI,gBAAA;AAlHR;AAqHQ;EACI,gDAAA;EACA,YAAA;AAnHZ;AAqHQ;EACI,aAAA;EAEA,gBAAA;AApHZ;AAsHQ;EACI,YAAA;EACA,uDAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AApHZ;AAsHQ;EACI,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AApHZ;AAyHI;EACI,eAAA;AAvHR;AA0HI;EACI,gBAAA;EACA,aAAA;EAEA,eAAA;EACA,OAAA;AAzHR;AA2HA;EACI,eAAA;AAzHJ;AA2HI;EACI,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;AAzHR;AA4HQ;EACI,eAAA;EACA,YAAA;EACA,WAAA;AA1HZ;AA4HQ;EACI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AA1HZ;AAmII;EACI,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAlIR;;AAsIA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACC,aAAA;EACA,uBAAA;EAEA,kBAAA;AApIL;AAqIK;EACG,gBAAA;EACJ,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAnIJ;AAqIK;EACI,YAAA;AAnIT;;AAsIC;EAEG,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;AApIJ;AAqII;EACI,kBAAA;AAnIR;AAoIQ;EACI,sBAAA;EACZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAlIA;AAqIQ;EACI,gBAAA;AAnIZ;AAoIY;EACI,aAAA;EACA,cAAA;EACA,gDAAA;EACA,mBAAA;EACA,WAAA;EAEZ,YAAA;AAnIJ;AAoIgB;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAlIpB;AAoIgB;EACI,iBAAA;EAEhB,WAAA;EACA,YAAA;EACA,gDAAA;EAGA,gBAAA;EACA,wBAAA;EAGA,YAAA;AAvIJ;AA+IgB;EAEI,yBAAA;EACA,gDAAA;EAEA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AA/IpB;AAoJA;EACI,iBAAA;AAlJJ;AAqJgB;EACI,gBAAA;AAnJpB;AAoJoB;EACI,kBAAA;AAlJxB;AAoJoB;EACI,sBAAA;EACxB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EAGA,YAAA;AApJA;AAwJoB;EACI,sBAAA;EACxB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAtJA;AA0JoB;EACI,sBAAA;EACxB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAxJA;AAkKI;EACI,gBAAA;EACA,sBAAA;EACR,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;AAhKA;AAkKI;EACE,eAAA;AAhKN;AAmKI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AAjKR;AAkKQ;EACC,UAAA;EACA,WAAA;EACT,4BAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EAEA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AAjKA;AAsKQ;EACI,wCAAA;AApKZ;;AAyKC;EACG,eAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,OAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;AAtKJ;AAuKC;EAEC,kBAAA;EACA,WAAA;EAEA,uBAAA;EAEA,sBAAA;EACA,sBAAA;EACA,wDAAA;EACA,mBAAA;AAxKF;AA6KQ;EACI,sBAAA;EACA,eAAA;EAEZ,gBAAA;EACA,iBAAA;EACA,mBAAA;AA5KA;AA8KA;EACI,sBAAA;EACJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA5KA;AAiLQ;EACI,sBAAA;EACZ,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA/KA;AAkLQ;EACI,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mDAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAhLZ;AAkLQ;EACI,aAAA;EACA,oCAAA;AAhLZ;AAkLQ;EACI,yBAAA;AAhLZ;AA2LQ;EACI,kBAAA;EACA,cAAA;AAzLZ;AA0LY;EACI,wCAAA;AAxLhB;AA2LY;EAEI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACJ,+BAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AA3LZ;AA+LgB;EACI,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACJ,cAAA;AA7LhB;AAgMgB;EAEI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AA/LpB;AAkMgB;EAEI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACL,cAAA;EACA,0BAAA;AAjMf;AAoMgB;EACC,eAAA;AAlMjB;;AA4MI;EACI,iBAAA;EACA,WAAA;AAzMR;AA0MQ;EACI,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAxMZ;AA2MQ;EACI,cAAA;AAzMZ;AA0MA;EACI,aAAA;EACA,8BAAA;AAxMJ;AA0MA;EACI,gBAAA;AAxMJ;AAyMI;EACA,cAAA;EACA,eAAA;EACJ,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAvMA;AAyMI;EACI,cAAA;EACA,eAAA;EACJ,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;AAvMJ;AA4MA;EACC,eAAA;AA1MD;AA4MA;EACI,eAAA;EACA,kBAAA;AA1MJ;AA2MI;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAzMR;AA2MI;EACI,wCAAA;AAzMR;AA6MI;EACI,aAAA;EACA,cAAA;EACA,gDAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA3MR;AA4MQ;EACI,kBAAA;EACZ,WAAA;EACA,YAAA;EACA,gDAAA;EAGA,gBAAA;EACA,wBAAA;EAGA,YAAA;AA9MA;AAoNU;EACE,WAAA;AAlNZ;AAqNQ;EAEI,yBAAA;EACA,gDAAA;EAEA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AArNZ;AAwNQ;EACI,gBAAA;AAtNZ;AAuNY;EACI,kBAAA;AArNhB;AAuNY;EACI,sBAAA;EAChB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;AArNA;AAwNY;EACI,sBAAA;EAChB,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAtNA;AA2NY;EACI,sBAAA;EAChB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAzNA;AAmOY;EACI,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AAjOhB;AAoOY;EACI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EAChB,4BAAA;AAlOA;;AAwOI;EACI,iBAAA;AArOR;AAuOI;EACI,iBAAA;EACA,kBAAA;AArOR;AAyOQ;EACI,eAAA;EAEZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAxOA;AA2OQ;EACI,eAAA;EAEZ,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AA1OA;AA2OA;EACI,sBAAA;EACJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAzOA;AAgPC;EACG,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AA9OJ;AA+OC;EACG,YAAA;EACA,YAAA;EAEJ,+BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AA9OA;;AAmPA;EACG;IACC,kBAAA;EAhPF;AACF;AAkPA;EACI;IACI,aAAA;IACA,cAAA;EAhPN;AACF;AAqPA;EACI;IACI,sBAAA;IACA,uBAAA;EAnPN;AACF;AAuPA;EAEI;IACI,sBAAA;IACA,uBAAA;EAtPN;AACF;AAyPA;EACA;IACI,sBAAA;IACA,yBAAA;EAvPF;EAyPF;IACI,aAAA;IACA,cAAA;IACA,gDAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;EAvPF;EAyPF;IACI,uBAAA;EAvPF;EA0PF;IAEI,uBAAA;EAzPF;AACF;AA4PA;EAEI;IACI,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;EA3PN;EA6PE;IACI,sBAAA;EA3PN;EA6PE;IACI,sBAAA;IACA,uBAAA;EA3PN;AACF;AAmQA;EACI;IACI,gBAAA;EAjQN;EAmQE;IACI,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,cAAA;IACA,4BAAA;EAjQN;EAoQI;IACE,sBAAA;IACA,0BAAA;EAlQN;EAoQF;IACE,iBAAA;IAEA,gBAAA;EAnQA;EAsQF;IAEI,iBAAA;EArQF;EAwQA;IAEE,iBAAA;EAvQF;EA0QA;IAEE,iBAAA;EAzQF;EA4QA;IACE,qBAAA;EA1QF;EA6QA;IAEE,yBAAA;EA5QF;EA+QA;IACE,yBAAA;EA7QF;EA+QA;IACE,yBAAA;EA7QF;EA+QA;IACE,yBAAA;EA7QF;EAgRA;IAEE,sBAAA;EA/QF;EAiRE;IACI,2BAAA;EA/QN;EAmRE;IACI,uBAAA;IACA,gBAAA;EAjRN;EAmRE;IACI,uBAAA;IACA,eAAA;EAjRN;EAqRA;IACE,yBAAA;EAnRF;EAwRA;IACE,sBAAA;EAtRF;EA8RA;IACE,sBAAA;IACA,uBAAA;EA5RF;EA8RA;IACE,0BAAA;EA5RF;EAiSA;IACC,yBAAA;EA/RD;EAkSA;IAEE,0BAAA;EAjSF;EAsSF;IACE,sBAAA;IACA,4BAAA;EApSA;EAuSF;IACI,sBAAA;IACA,0BAAA;EArSF;EAuSA;IACE,sBAAA;IACA,0BAAA;EArSF;EAuSA;IACE,uBAAA;IACA,sBAAA;EArSF;EAuSA;IACE,wBAAA;IACA,oBAAA;IACA,qBAAA;EArSF;EAwSF;IACE,sBAAA;IACA,0BAAA;IACA,eAAA;EAtSA;EAwSF;IACI,sBAAA;IACA,0BAAA;EAtSF;EAwSA;IACE,sBAAA;IACA,0BAAA;EAtSF;EA+SF;IACE,uBAAA;EA7SA;EA+SF;IACI,sBAAA;EA7SF;EA+SF;IACI,sBAAA;IACA,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EA7SF;EAgTA;IACE,sBAAA;IACA,0BAAA;EA9SF;EAgTA;IACE,YAAA;EA9SF;EAgTA;IACE,sBAAA;IACA,0BAAA;IACA,WAAA;EA9SF;EAkTF;IACE,sBAAA;EAhTA;EAqTF;IACE,sBAAA;IACA,0BAAA;EAnTA;EAqTF;IACI,2BAAA;EAnTF;EAqTA;IAEE,YAAA;EApTF;EAuTA;IACE,sBAAA;EArTF;EA4TA;IACE,sBAAA;EA1TF;EA4TA;IACE,sBAAA;IACA,0BAAA;EA1TF;EA6TF;IACI,aAAA;IACA,SAAA;IACA,+CAAA;IACA,qCAAA;IACA,eAAA;IACA,WAAA;IACA,mBAAA;IACA,YAAA;IACA,qBAAA;EA3TF;EA8TA;IACE,qCAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;IACA,YAAA;EA5TF;EA8TA;IACE,iDAAA;IACA,aAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;EA5TF;EA8TA;IACE,YAAA;IACA,gBAAA;IACA,iDAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;EA5TF;EA8TA;IACE,sBAAA;IACA,0BAAA;EA5TF;EA8TA;IACE,eAAA;IACA,gBAAA;EA5TF;EA8TA;IACE,gBAAA;IACA,cAAA;IACA,iBAAA;EA5TF;EA8TA;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,YAAA;EA5TF;EAiUA;IAEE,mBAAA;IAEA,WAAA;IACA,aAAA;IACA,aAAA;IACA,iBAAA;EAjUF;EAmUA;IACE,eAAA;EAjUF;EAmUA;IACE,eAAA;EAjUF;EAmUA;IACE,mBAAA;IACA,SAAA;IACA,yBAAA;IACA,YAAA;IACA,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;IACA,YAAA;IACA,YAAA;EAjUF;EAoUA;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;EAlUF;EAoUF;IACI,0BAAA;EAlUF;EAoUF;IACI,0BAAA;EAlUF;EAoUF;IACI,6BAAA;EAlUF;EAoUF;IACI,sBAAA;IACA,uBAAA;EAlUF;EAoUF;IACI,2BAAA;EAlUF;AACF;AAqUC;EACG,oBAAA;AAnUJ;AAqUI;EACI,kBAAA;AAnUR;AAoUQ;EACI,aAAA;EACA,gBAAA;EACA,YAAA;AAlUZ;AAoUQ;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;EACA,gBAAA;AAlUZ;AAqUQ;EACI,sBAAA;EACZ,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;AAnUA;AAsUQ;EACG,YAAA;EACA,YAAA;EACJ,SAAA;EACD,mBAAA;EACN,YAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AApUA;;AAyUC;EAEI;IACG,sBAAA;IACA,uBAAA;EAvUN;EA2UM;IACI,4BAAA;EAzUV;EA4UM;IACI,YAAA;IACA,YAAA;IACA,YAAA;IACA,yBAAA;IACA,mBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;IACA,cAAA;EA1UV;EA6UM;IAEI,oBAAA;EA5UV;EAgVM;IACI,sBAAA;IACA,uBAAA;EA9UV;EAgVM;IACI,sBAAA;IACA,yBAAA;EA9UV;EAgVM;IACI,sBAAA;IACA,uBAAA;EA9UV;EAgVM;IACI,sBAAA;EA9UV;EAiVM;IAEI,0BAAA;EAhVV;EAmVM;IACI,2BAAA;EAjVV;AACF;AAmVI;EAEI;IACI,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;EAlVV;EAoVM;IACI,wBAAA;IACA,uBAAA;EAlVV;AACF;AAoVI;EACI;IACI,2BAAA;EAlVV;AACF;AAqVI;EAEI;IACI,gBAAA;IACA,aAAA;IACA,eAAA;IACA,OAAA;EApVV;EAuVM;IACI,uBAAA;IACA,sBAAA;EArVV;EAwVM;IACI,2BAAA;EAtVV;AACF;AAyVI;EACI;IACI,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;EAvVV;EAyVM;IACI,2BAAA;EAvVV;EAyVM;IACI,gBAAA;IACA,aAAA;IACA,eAAA;IACA,OAAA;EAvVV;AACF;AAyVI;EAEJ;IACI,4BAAA;EAxVF;EA0VF;IACI,sBAAA;IACA,uBAAA;EAxVF;EA2VF;IACI,sBAAA;IACA,uBAAA;EAzVF;AACF;AA6VI;EACA;IACI,sBAAA;IACA,uBAAA;EA3VN;AACF;AA+VI;EACI;IACI,wBAAA;IACA,yBAAA;EA7VV;EA+VM;IACI,sBAAA;IACA,0BAAA;IACA,sBAAA;EA7VV;AACF;AAiWA;EACI;IACI,wBAAA;IACA,wBAAA;EA/VN;AACF;AAkWI;EACA;IACI,mBAAA;IACA,WAAA;IACA,aAAA;IACA,aAAA;IACA,iBAAA;EAhWN;AACF;AAoWA;EACI;IACI,wBAAA;IACA,wBAAA;EAlWN;AACF;AAsWI;EACJ;IACI,2BAAA;EApWF;EA0WF;IACI,sBAAA;EAxWF;EA2WF;IACI,sBAAA;IACA,0BAAA;IACA,WAAA;EAzWF;EA2WF;IACI,sBAAA;IACA,wBAAA;EAzWF;EA2WF;IACI,0BAAA;EAzWF;EA2WF;IACI,2BAAA;EAzWF;AACF;AA6WI;EAEJ;IACI,sBAAA;IACA,0BAAA;EA5WF;EA8WF;IACI,oBAAA;EA5WF;EA8WF;IACI,sBAAA;IACA,wBAAA;EA5WF;EA8WF;IACI,uBAAA;IACA,sBAAA;EA5WF;EA8WF;IAEI,oBAAA;EA7WF;AACF;AA+WI;EACJ;IACI,mBAAA;IACA,WAAA;IACA,aAAA;IACA,aAAA;IACA,iBAAA;EA7WF;EA+WF;IACI,2BAAA;EA7WF;AACF;AA+WI;EAEJ;IACI,sBAAA;EA9WF;EAiXF;IACI,sBAAA;IACA,uBAAA;EA/WF;EAiXF;IACI,0BAAA;EA/WF;AACF;AA2XI;EACI;IAEI,gBAAA;EA1XV;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Assistant&family=Roboto:ital,wght@1,100&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Assistant:wght@400;800&family=Roboto:ital,wght@1,100&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Assistant:wght@400;800&family=Roboto:ital,wght@1,100&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Assistant:wght@400;600;700;800&family=Roboto:ital,wght@1,100&display=swap');\n\n*{\nfont-family: Assistant;\ncolor: #152745;\nmargin: 0;\npadding: 0;\nbox-sizing: border-box;\n}\n* {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.toastifyclass{\n   position: fixed;\n    top: 0;\n    right: 0; \n}\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n::-webkit-scrollbar:vertical {\n    width: 7px;\n    height: 155px;\n    min-height: 20px;\n    border-radius: 10px;\n  }\n  \n  ::-webkit-scrollbar-thumb:vertical {\n    background-clip: padding-box;\n    border-radius: 10px;\n    background-color: #979797;\n    width: 7px;\n    height: 155px;\n    min-height: 30px;\n  }\n\n  ::-webkit-scrollbar:horizontal {\n    width: 7px;\n    height: 155px;\n    min-height: 20px;\n    border-radius: 10px;\n  }\n  \n  ::-webkit-scrollbar-thumb:horizontal{\n \n    background-clip: padding-box;\n    border-radius: 10px;\n    background-color: #000000;\n    width: 7px;\n    height: 155px;\n    min-height: 30px;\n \n  }\n\n  \nbody{\n    font-size: 3.2vw;\n    // max-width: 428px;\n    overflow-x: hidden;\n    // overflow-x: scroll;\n//   min-width: 428px;\n align-items: center;\n width: 100%;\n    display: flex;\n    justify-content: center;\n    overflow-y: scroll;\n    height:100% !important;\n    \n}\n// body::-webkit-scrollbar {\n//     width: 2px; \n//     // background-color: #f1f1f1; \n//   }\n  \n//  body::-webkit-scrollbar-thumb {\n//     background-color: #9b1313; \n//     // border-radius: 6px; \n//   }\n#root{\n    // max-width: 441px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    // height: 100vh;\n}\n#blurbackground{\n// background: rgb(111,111,111,0.5);\n}\ndiv.app{\n    max-width: 441px;\n\n}\ndiv.bankstatement{\n    // height: 294vw;\n    width: 100%;\n    position: relative;\n    z-index: 0;\n    margin-top: 128px;\n    div.navbar{\n        box-shadow: 0px 2px 4px 0px #1527450D;\n        height: 111px;\n        p{\n            position: absolute;\n            font-family: Assistant;\n            font-size: 30px;\n            font-weight: 700;\n            line-height: 30px;\n            letter-spacing: 0em;\n            text-align: left;\n            margin-top: 3%;\n            margin-left: 116px;\n\n        }\n        img{\n            margin-left: 13%;\n        }\n    }\ndiv.mybody{\n\n    // padding-inline: 4%;\n    div.text{\n        display: flex;\n         gap: 1rem; \n        background-color: rgba(21, 39, 69, 0.031372549);\n        color: rgba(21, 39, 69, 0.5019607843);\n        margin-top: 10%;\n        padding: 2%;\n border-radius: 10px;\n        \n    width: 360px;   \n      img{\n        height: 1rem;\n        margin-top: 1%;\n      }\n      div.some_text{\n        p{\n        color:#15274580;\n        font-weight: 600;\n        font-size: 14px;\n        margin-top: 0px;\n        width: 293px;\n        }\n      }\n    }\n\n    div.upper_middle{\n        margin-top: 1rem;\n        position: relative;\n        top: 9px;\n        h1{\n        font-family: Assistant;\n        font-size: 20px;\nfont-weight: 400;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: left;\n        }\n        button{\n            background-color: #16C96F;\n            font-family: Assistant;\n            font-size: 12px;\n            border-radius: 4px 4px  0px 0px;\n            width: 105px;\n            height: 21px;\nfont-weight: 600;\nline-height: 16px;\nletter-spacing: 0.04em;\ntext-align: center;\ncolor:  #FFFFFF;\nborder: none;\npadding: 3px;\nborder-radius: 4px, 4px, 0px, 0px;\n        }\n\n    }\ndiv.slider{\n    margin-top: 1rem;\n    display: flex;\n    align-items: center;\n    width: 356px;\n   .line{\n    flex:1;\n   border:1px solid  rgba(21, 39, 69, 0.201961);\n   }\n   span{\n    font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: center;\ncolor: #15274599;\nmargin-inline: 16px;\n;\n\n   }\n}\n\n    div.middlecontainer{\n        box-shadow: 0px 0px 4px 0px #15274533;\n        padding: 18px;\n        width: 360px;\n        height: 244px;\n        border-radius: 10px;\n        h1{\n            font-family: Assistant;\n            font-size: 20px;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\n\n\n        }\n    }\n    p{\n      \n\n        font-family: Assistant;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n        letter-spacing: 0em;\n        text-align: left;\n        margin-top: 20px;\n        color: #152745B2;\n\n    }\n    span{\n        font-weight: 600;\n        color:  #152745B2;\n        ;\n    }\n\n    div.statement{\n        display: flex;\n        justify-content: space-between;\n        div.option{\n            display: flex;\n            background-color: rgba(22, 201, 111, 0.1019607843);\n            height: 28px;\n            width: 116px;\n            padding: 2px;\n            justify-content: center;\n            align-items: center;\n            border-radius: 5px;\n\np{\n    font-weight: 400;\n    font-size: 12px;\n    margin-top: 17px;\n    color:  #152745;\n}\nspan{\n    font-weight: 600;\n    color:  #152745;\n    font-size: 12px;\n}\n        }\n    }\n\n    div.submitbtn{\n        display: flex;\n        justify-content: center;\n        .submit{\n            display: flex;\n            background-color: #FC6603;\n            border: none;\n            /* padding: 7px; */\n            /* padding-inline: 13px; */\n            border-radius: 10px;\n            width: 240px;\n            height: 60px;\n            justify-content: center;\n            align-items: center;\n            margin-top: 24px;\n        h1{\n            font-family: Assistant;\nfont-size: 20px;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: center;\ncolor: #FFFFFF;\nmargin-left: 12px;\n\n        }\n        img{\n            margin-top: -14px;\n        }\n        }\n    }\n\n    div.upload_container{\n        width: 360px;\n        margin-top: 1rem;\n        box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);\n        padding: 5%;\n        height: 226px;\n        border-radius: 10px;\n\n        h1{\n            font-family: Assistant;\n            font-size: 20px;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\n        }\n\n        p{\n \n\nfont-family: Assistant;\nfont-size: 14px;\nfont-weight: 400;\nline-height: 18px;\nletter-spacing: 0em;\ncolor:  #152745B2;\ncolor:  #152745B2;\n\n;\n\n        }\n        span{\n            font-weight: 600;\n            color: #152745B2;\n        \n        }\n\n        div.submitbtn{\n            button{\n\n                border-radius: 10px;\n                border: 1px solid #FC6603;\n                background-color: #FFFFFF;\n                padding: 4%;\n                padding-bottom: 0%;\n                width: 240px;\n                height: 60px;\n    \np{\n    font-family: Assistant;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 26px;\n    letter-spacing: 0em;\n    color: #FC6603;\n    margin-left: 1rem;\n    margin-top: -1px;\n;\n\n}\n\n            }\n        }\n    }\n\n    div.footer{\n       margin-top: 3rem;\n        display: flex;\n        justify-content: center;\n      \n        margin-bottom: 0px;\n        img{\n            height: 15px;\n            \n        }\n        p{\n            margin-top: -1px;\n            color: #16C96F;\n            margin-left: 2px;\n            font-size: 400;\n        }\n    }\n}\n\n}\nbody{\n    position: relative;\n    // background-color: rgba(0, 0, 0, 0.5) ;/* Background overlay */\n    // backdrop-filter: blur(8px); /* Adjust the blur amount as needed */\n    z-index: 999; /* Ensure the background is on top of other content */\n  }\n  \ndiv.process{\n    position: fixed;\n    bottom: 14px;\n    z-index: 1200;\n    border-radius: 20px;\n    margin-left: -14px;\n    background-color: #FFFFFF;\n    // -webkit-backdrop-filter: blur(8px);\n    // backdrop-filter: blur(8px);\n    box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.1019607843);\n    padding: 2%;\n    width: 389px;\n    padding: 33px;\n    height: 454px;\n    div.content{\n        h1{\n            font-family: Assistant;\nfont-size: 1.3rem;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:#152745;\n;\n        }\n        p{\n            font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:#152745;\n\n        }\n    }\n\n    div.steps{\n        span{\n        font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #15274566;\n;\n        }\n\n        p{\n            margin-bottom: 4px;\n            span{\n            font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:#152745;\nmargin-left: 4%;\n            }\n\n        }\n\n    }\n    div.regulation{\n        display: flex;\n       \n        margin-top: 3rem;\n        img{\n            margin-left: 5%;\n            height: 2rem;\n            margin-top: -6px;\n        }\n        p{\n            font-family: Assistant;\n            font-size: 12px;\nfont-weight: 400;\nline-height: 16px;\nletter-spacing: 0em;\ntext-align: left;\ncolor: #15274566;\n        }\n    }\n\n    div.proceed{\n        display: flex;\n        justify-content: center;\n        margin-top: 1rem;\n        button{\n            border-radius: 10px;\n            gap: 10px;\n            background-color: #FC6603;\n            color: white;\n            font-family: Assistant;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 26px;\n            letter-spacing: 0em;\n            text-align: center;\n            border: none;\n            padding: 5%;\n            padding-inline: 15%;\n            width: 240px;\n            height: 60px;\n        }\n    }\n\n}\n\n\ndiv.verifyotp{\n    height: auto;\n    width: 100%;\n  \nposition: relative;\nz-index: 0;\ntop: 40px;\n    div.navbar{\n        box-shadow: 0px 2px 4px 0px #1527450D;\n        height: 106px;\n        p{\n            position: absolute;\n            font-family: Assistant;\n            font-size: 30px;\n            font-weight: 700;\n            line-height: 30px;\n            letter-spacing: 0em;\n            text-align: left;\n            margin-left: 82px;\n            margin-top: 12px;\n\n        }\n        img{\n            margin-left: 10%;\n        }\n    }\n    div.mybody{\n        padding-inline: 10%;\n        margin-top: 127px;\n    div.bank{\n        display: flex;\n        justify-content: space-between;\n        margin-top: 24px;\n    }\n\n    div.otppanel{\n        text-align: center;\n        margin-top: 23px;\n        div.inp{\n            p{\n                font-family: Assistant;\n                font-size: 18px;\nfont-weight: 400;\nline-height: 24px;\nletter-spacing: 0em;\n\n            }\n            input{\n                width: 51.3px !important;\n                height: 53px;\n                border-radius: 2.5px;\n                border-radius: 2.5px;\n                margin-left: 5px;\n                border: 0.63px solid rgba(21, 39, 69, 0.3019607843);\n                padding: 3%;\n                font-family: Assistant;\n                font-size: 20px;\n                font-weight: 600;\n                line-height: 26px;\n                letter-spacing: 0em;\n                text-align: center;\n                outline: none;\n                margin-top: 5px;\n}\n            input[type=number]:focus{\n                outline: none;\n                border: 0.63px solid #FC6603 !important;\n            }\n            .active{\n                border: 0.63px solid #FC6603\n            }\n\n            div.resend{\n                display: flex;\n                justify-content: space-between;\n                margin-top: 43px;\n                justify-content: center;\n                gap: 205px;\n\n\n.re{\nfont-family: Assistant;\nfont-size: 1rem;\nfont-weight: 700;\nline-height: 26px;\nletter-spacing: 0em;\ncolor: #15274580;\ntext-decoration: underline;\n}\n.resend{\n    font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 700;\nline-height: 26px;\nletter-spacing: 0em;\ncolor: #15274580;\ntext-decoration: underline;\n    color: #FC6603;\n}\n.resend:hover{\n\n    cursor: pointer;\n}\n\n                .time{\n                    font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: center;\ncolor:  #152745;\n;\n\n                }\n            }\n        }\n\n.warning{\n    font-family: Assistant;\n    font-size: 18px;\nfont-weight: 400;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: center;\nmargin-top: 23px;\nspan{\n    font-weight: 600;\n}\n\n\n}\nbutton{\n    margin-top: 20px;\n \npadding: 20px, 25px, 20px, 25px;\nborder-radius: 10px;\ngap: 10px;\nbackground-color: #FC6603;\ncolor:  #FFFFFF;\nborder: none;\n\nfont-family: Assistant;\nfont-size: 20px;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: center;\n\nwidth:240px;\nheight:60px;\n}\nbutton:disabled{\n    background-color:  #FC660366;\n    ;\n}\n.terms{\n    margin-top: 3rem;;\n    background: #FFFFFF;\n    font-family: Assistant;\n    font-size: 18px;\n\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: center;\n   span{\n  color:  #FC6603;\n  text-decoration: underline;\n  font-weight: 600;\n\n   }\n   span:hover{\n  cursor: pointer;\n     }\n}\n.finvu{\n    margin-top: 32px;\n    font-family: Assistant;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: 0em;\n    text-align: center;\n    color: #152745;\n    \n\n}\n\n    }\n    div.footer{\n        margin-top: 6rem;\n         display: flex;\n         justify-content: center;\n       \n         margin-bottom: 0px;\n         p{\n            margin-left: 4px;\n            margin-top: -1px;\n            font-family: Assistant;\nfont-size: 14px;\nfont-weight: 600;\nline-height: 18px;\nletter-spacing: 0em;\ntext-align: left;\ncolor: #16C96F;\n         }\n         img{\n            height: 17px;\n         }\n     }\n    }\n}\ndiv.navbarcomponent{\n    // width: 100vw;\n    // border: 1px solid black;\n    padding: 45px;\n    position: absolute;\n    top: 0;\n    // box-shadow: 0px 2px 4px 0px rgba(21, 39, 69, 0.0509803922);\n    left: 0px;\n    width: 100vw;\n    height: 114px;\n    display: flex;\n    justify-content: center;\n    gap: 25px;\n\n    h1{\n        display: inline;\n        font-family: Assistant;\n        font-size: 28px;\n        font-weight: 700;\n        line-height: 30px;\n        letter-spacing: 0em;\n        text-align: left;\n        color: #152745;\n        position: absolute;\n        left: 19%;\n    }\n    img{\n        height: 16px;\n        width: 10px;\n        margin-top: 8px;\n        position: absolute;\n        left: 8%;\n    }\n    img:hover{\n        cursor: pointer;\n    }\n}\n\ndiv.jointlogo{\n    display: flex;\n    justify-content: center;\n    gap: 135px;\n    position: relative;\n    top: 135px;\n    img{\n        width: min(20vw,97px);\n        width: 98px;\n        height: 48px;\n    }\n}\ndiv.selectbank{\n    // height: 100vh;\n    position: relative;\n    top: 10;\n    padding-inline: 21px;\n    top: 168px;\n   \n    div.input{\n    //     input:focus { \n    //         border:0;\n    //    }\n        input{\n            background-image: url('./common/images/search.svg');\n            background-repeat: no-repeat;\n            background-position:6%;\n            padding: 3%;\n            padding-inline: 16%;\nborder: 1px solid #15274533;\noutline: none;\nwidth: 360px;\nheight: min(15vw,64px);\nborder-radius: 10px;\nfont-family: Assistant;\nfont-size: 1.2rem;\nfont-weight: 400;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #15274566;\nbox-sizing: border-box;\n;\ntext-decoration: none; \n\n        }\n        input::placeholder{\n            font-family: Assistant;\n            font-size: 1.2rem;\n            font-weight: 400;\n            line-height: 24px;\n            letter-spacing: 0em;\n            text-align: left;\n            color:  #15274566;\n            text-decoration: none;\n        }\n    }\n    div.allbanks{\n        max-width: 360px !important;\ndiv.othersbank{\n    margin-top: 2rem;\n    h1{\n        font-family: Assistant;\nfont-size: 1.3rem;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #152745;\n;\nimg{\n    margin-left: 3px;\n    margin-top: -3px;\n}\n    }\n    h1:hover{\n        cursor: pointer;\n    }\n   .active{\n        color: #FC6603;\n    }\n\n    div.banks{\n        margin-top: 19px;\n        // border: 1px solid #15274512;\n        // padding:10px;\n        hr{\n            border: 1px solid #15274512;\n            width: 362px;\n        }\n        div.mybank{\n            display: flex;\n\n            margin-top: 10px;\n      \n        img{\n            height: 41px;\n            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2509803922);\n            border-radius: 50% 50%;\n            padding: 9px;\n            width: 41px;\n        }\n        span{\n            margin-left: 4%;\n            font-family: Assistant;\n            font-size: 1.2rem;\n            font-weight: 600;\n            line-height: 24px;\n            letter-spacing: 0em;\n            text-align: left;\n            color: #152745;\n            margin-top: 8px;\n;\n        }\n        }\n    }\n    div.banks:hover{\n        cursor: pointer;\n    }\n}\n    div.Banks{\n        margin-top: 1rem;\n        display: flex;\n        // justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 7%;\n    \ndiv.singlebank:hover{\n    cursor: pointer;\n}\n    div.singlebank{\n        width: 101px;\n        border: 1px solid black;\n        padding: 0%;\n        text-align: center;\n        margin-top: 6%;\n        border: 0.5px solid #FC6603;\n        border-radius: 5px;\n        height: 103px;\n      \n    \n        img{\n            margin-top: 5px;\n            height: 41px;\n            width: 47px;\n        }\n        p{\n            font-family: Assistant;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 18px;\n            letter-spacing: 0em;\n            text-align: center;\n            margin-top: 14px;\n            color: rgba(21, 39, 69, 0.6);\n\n        }\n    }\n\n}\n\n    }\nmin-height: 500px;\n    div.footer2{\n        width: 100%;\n        // border: 1px solid black;\n        display: flex;\n        justify-content: center;\n        position: relative;\n        bottom: -57px;\n    }\n\n}\ndiv.footer{\n    position: relative;\n    bottom: 0px;\n    margin-top: 2rem;\n     display: flex;\n     justify-content: center;\n   \n     margin-bottom: 0px;\n     p{\n        margin-left: 4px;\n    margin-top: -1px;\n    font-family: Assistant;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #16C96F;\n     }\n     img{\n         height: 1rem;\n     }\n }\n div.linkaccount{\n    // margin-top: 7rem;\n    padding-inline: 9%;\n    position: relative;\n    z-index: 0;\n    top: 129px;\n    margin-top: 152px;\n    div.content{\n        margin-top: -106px;\n        p{\n            font-family: Assistant;\nfont-size: 17px;\nfont-weight: 400;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\n// width: 359px;\n        }\n        div.bank_account{\n            margin-top: 44px;\n            div.bank{\n                display: flex;\n                margin-top: 6%;\n                border: 1px solid rgba(21, 39, 69, 0.3019607843);\n                border-radius: 10px;\n                padding: 2%;\n              \n    width: 366px;\n                img{\n                    height: 30px;\n                    width: 30px;\n                    margin-top: 11px;\n                    margin-left: 4px;\n                }\n                input{\n                    margin-left: 29px;\n    \n    width: 25px;\n    height: 25px;\n    border: 1px solid #1527454D;\n    // accent-color: #16C96F;\n    // color: white !important;\n    margin-top: 19px;\n    -webkit-appearance: none; \n    // outline: none; \n    // cursor: pointer; \n    color: white;\n    // position: absolute;\n    // opacity: 0;\n    // z-index: -1;\n                }\n             \n                  \n                  \n                input[type=checkbox]:checked::before{\n             \n                    background-color: #16C96F ;\n                    content: url(\"./common/images/checkmark.svg\");\n                    \n                    color: white;\n                    display: block;\n                    font-size: 26px;\n                    text-align: center;\n                    line-height: 20px;\n                    height: 27px;\n                    width: 27px;\n                    margin-left: -1px;\n                    margin-top: -2px;\n                    \n\n                }\n\n.checkedinput{\n    margin-left: 27px;\n}\n  \n                div.information{\n                    margin-left: 10%;\n                    p{\n                        margin-bottom: 0px;\n                    }\n                    .name{\n                        font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #15274599;\n// width: 128px;\n// word-wrap: break-word;\nwidth: 223px;\n   \n;\n                    }\n                    .account{\n                        font-family: Assistant;\nfont-size: 18px;\nfont-weight: 600;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #152745;\n;;\n\n                    }\n                    .type{\n                        font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #FC6603;\n;\n\n                    }\n\n\n                }\n            }\n        }\n    }\n    .go_to_linked_accounts{\n        margin-top: 16px;;\n        font-family: Assistant;\nfont-size: 18px;\nfont-weight: 600;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\ncolor: #FC6603;\ntext-decoration: underline;\ntext-decoration-skip-ink: auto; \n    }\n    .go_to_linked_accounts:hover{\n      cursor: pointer;\n    }\n\n    div.submitbtn{\n        margin-top: 3rem;\n        display: flex;\n        justify-content: center;\n        button{\n         width: 70%;\n         height: 10%;\npadding: 20px 25px 20px 25px;\nborder-radius: 10px;\ngap: 10px;\nbackground-color:  #FC6603;\n\nfont-family: Assistant;\nfont-size: 1.3rem;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: center;\ncolor: white;\noutline: none;\nborder: none;\n\n;\n\n        }\n        button:disabled{\n            background-color:  #FC660366;\n            ;\n        }\n    }\n }\n div.otpcontainer{\n    position: fixed;\n    width: 100vw;\n    height: 100%;\n    z-index: 1000;\n    background-color: rgba(0, 0, 0, 0.2);\n    bottom: 0px;\n    left: 0;\n    align-items: center;\n    /* text-align: center; */\n    display: flex;\n    justify-content: center;\n div.otp{\n\n  position: absolute;\n  bottom: 8px;\n//   z-index: 2;\n  background-color: white;\n//   margin-left: -20px;\n  padding: min(8%, 35px);\n  width: min(420px, 93%);\n  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.1019607843);\n  border-radius: 20px;\n//   max-height: 366px;\n\n\n    div.inp{\n        p{\n            font-family: Assistant;\n            font-size: 16px;\n\nfont-weight: 400;\nline-height: 24px;\nletter-spacing: 0em;\n\nspan{\n    font-family: Assistant;\nfont-size: 16px;\nfont-weight: 600;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\n\n}\n\n        }\n        h1{\n            font-family: Assistant;\nfont-size: 1.2rem;\nfont-weight: 600;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\n\n        }\n        input{\n            width: 51px !important;\n            height: 51px !important;\n            border-radius: 2.5px;\n            border-radius: 2.5px;\n            margin-left: 3px;\n            border: 0.63px solid rgba(21, 39, 69, 0.3019607843);\n            padding: 1%;\n            font-family: Assistant;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 26px;\n            letter-spacing: 0em;\n            text-align: center;\n            outline: none;\n            margin-top: 9px;\n}\n        input[type=number]:focus{\n            outline: none;\n            border: 1px solid #FC6603 !important;\n        }\n        .active{\n            border: 1px solid #FC6603\n        }\n\n        // button{\n        //     width: 20%;\n        //     height: 10%;\n        //     outline: none;\n        //     border: none;\n        //     border-radius: 10px;\n        // }\n       \n        div.resend{\n            text-align: center;\n            margin-top: 7%;\n            button:disabled{\n                background-color:  #FC660366;\n                ;\n            }\n            button{\n              \n                width: 60%;\n                height: 5vh;\n                margin-top: 1.8rem;\n                width:240px;\n                height:60px;\n            padding: 20px, 25px, 20px, 25px;\n            border-radius: 10px;\n            gap: 10px;\n            background-color: #FC6603;\n            color:  #FFFFFF;\n            border: none;\n            \n            font-family: Assistant;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 26px;\n            letter-spacing: 0em;\n            text-align: center;\n            \n            }\n            p{\n                .didnotreceive{\n                    font-family: Assistant;\n                    font-size:1.2rem;\n                    font-weight: 400;\n                    line-height: 31px;\n                    letter-spacing: 0em;\n                    text-align: center;\n                color: #152745;\n                    \n                }\n                .receive{\n                 \n                    font-family: Assistant;\n                    font-size: 18px;\n                    font-weight: 700;\n                    line-height: 31px;\n                    letter-spacing: 0em;\n                    text-align: center;\n                    text-decoration: underline;\n                    color: #9AA2AF;\n                \n                }\n                .receive2{\n                 \n                    font-family: Assistant;\n                    font-size: 18px;\n                    font-weight: 700;\n                    line-height: 31px;\n                    letter-spacing: 0em;\n                    text-align: center;\n               color: #FC6603;\n               text-decoration: underline;\n                }\n                \n                .receive2:hover{\n                 cursor: pointer;\n                }\n\n            }\n        }\n    }\n\n }\n}\n div.confirmconsent{\n    .consentDetail{\n        margin-top: 150px;\n        padding:3%;\n        h1{\n            font-family: Assistant;\n            font-size: 1.3rem;\n            font-weight: 600;\n            line-height: 26px;\n            letter-spacing: 0em;\n            text-align: left;\n            margin-top: 9px;\n            margin-left: 4px;\n\n        }\n        .consentform{\n            margin-top: 7%;\n.date{\n    display: flex;\n    justify-content: space-between;\n}\n.addaccount{\n    margin-top: 18px;\n    .plus{\n    margin-top: 5%;\n    font-size: 18px;\nfont-weight: 600;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\ncolor: #FC6603;\ntext-decoration: none;\n    }\n    .addacn{\n        margin-top: 5%;\n        font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #FC6603;\n    text-decoration: underline;\n    margin-left: 6px;\n        }\n\n}\n\n.addaccount:hover{\n cursor: pointer;\n}\ndiv.submit{\n    margin-top: 15%;\n    text-align: center;\n    button{\n        border: none;\n        width: 240px;\n        height: 60px;\n        background-color: #FC6603;\n        border-radius: 10px;\n        font-size: 1.3rem;\n        font-weight: 600;\n        line-height: 26px;\n        letter-spacing: 0em;\n        text-align: center;\n        color: #FFFFFF;\n    }\n    button:disabled{\n        background-color: rgba(252, 102, 3, 0.4);\n    }\n}\ndiv.bank_account{\n    div.bank{\n        display: flex;\n        margin-top: 7%;\n        border: 1px solid rgba(21, 39, 69, 0.3019607843);\n        border-radius: 10px;\n        padding: 2%;\n        width: 360px;\n        input{\n            margin-left: 147px;\nwidth: 25px;\nheight: 25px;\nborder: 1px solid #1527454D;\n// accent-color: #16C96F;\n// color: white !important;\nmargin-top: 19px;\n-webkit-appearance: none; \n// outline: none; \n// cursor: pointer; \ncolor: white;\n// position: absolute;\n// opacity: 0;\n// z-index: -1;\n        }\n     \n          img{\n            width: 36px;\n          }\n          \n        input[type=checkbox]:checked::before{\n     \n            background-color: #16C96F ;\n            content: url(\"./common/images/checkmark.svg\");\n            \n            color: white;\n            display: block;\n            font-size: 26px;\n            text-align: center;\n            line-height: 20px;\n            height: 27px;\n            width: 27px;\n            margin-left: -1px;\n            margin-top: -2px;\n\n        }\n        div.information{\n            margin-left: 10%;\n            p{\n                margin-bottom: 0px;\n            }\n            .name{\n                font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #15274599;\nmax-width: 88px;\n;\n            }\n            .account{\n                font-family: Assistant;\nfont-size: 1.2rem;\nfont-weight: 600;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #152745;\n// max-width: 2px;\n;;\n\n            }\n            .type{\n                font-family: Assistant;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 21px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:  #FC6603;\n;\n\n            }\n\n\n        }\n    }\n}\n\n            .field{\n                font-family: Assistant;\n                font-size: 1.2rem;\n                font-weight: 600;\n                line-height: 24px;\n                letter-spacing: 0em;\n                text-align: left;\n                color: #152745CC;\n                \n            }\n            .value{\n                font-family: Assistant;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 21px;\n                letter-spacing: 0em;\n                text-align: left;\ncolor: #15274599;                \n            }\n        }\n    }\n }\n div.finalresults{\n    div.logo{\n        margin-top: -81px;\n    }\n    div.content{\n        margin-top: 182px;\n        text-align: center;\n        img{\n            // width: min(49vw,200px);\n        }\n        h1{\n            margin-top: 20%;\n          \nfont-size: 2rem;\nfont-weight: 700;\nline-height: 32px;\nletter-spacing: 0em;\n\n        }\n        p{\n            margin-top: 10%;\n         \nfont-size: 1.2rem;\nfont-weight: 400;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: center;\n.wait{\n    font-family: Assistant;\nfont-size: 18px;\nfont-weight: 700;\nline-height: 24px;\nletter-spacing: 0em;\ntext-align: center;\n\n}\n        }\n    \n  \n }\n .myybtn{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    margin-top: 94px;\n button{\n    width: 240px;\n    height: 60px;\n\npadding: 20px, 25px, 20px, 25px;\nborder-radius: 10px;\nborder: 1px solid #FC6603;\nfont-family: Assistant;\nfont-size: 20px;\nfont-weight: 600;\nline-height: 26px;\nletter-spacing: 0em;\ntext-align: center;\noutline: none;\nbackground-color:#FFFFFF;\ncolor:#FC6603 ;\n\n }\n}\n}\n@media screen and (max-width: 680px) {\n   body{\n    overflow-x: hidden;\n   }\n}\n@media screen and (max-width:427px) {\n    div.verifyotp div.mybody div.otppanel div.inp input  {\n        width: 46.3px;\n        height: 46.7px;\n    }\n\n   \n    \n}\n@media screen and (max-width:439px) {\n    div.otp div.inp input {\n        width: 50px !important;\n        height: 50px !important;\n    \n      \n    }\n}\n@media screen and (max-width: 423px){\n\n    div.otpcontainer div.otp div.inp input {\n        width: 48px !important;\n        height: 48px !important;\n    }\n    \n   }\n@media screen and (max-width: 415px){\ndiv.verifyotp div.mybody div.otppanel div.inp input {\n    width: 12vw !important;\n    height: 12.6vw !important;\n}\ndiv.linkaccount div.content div.bank_account div.bank {\n    display: flex;\n    margin-top: 6%;\n    border: 1px solid rgba(21, 39, 69, 0.3019607843);\n    border-radius: 10px;\n    padding: 2%;\n    width: 363px;\n}\ndiv.selectbank div.allbanks div.Banks div.singlebank {\n    width: 101px !important;\n \n}\ndiv.selectbank div.allbanks div.othersbank div.banks hr {\n   \n    width: 346px !important;\n}\n}\n\n@media screen and (max-width: 410px){\n\n    div.verifyotp div.mybody div.otppanel div.inp div.resend {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 43px;\n        justify-content: center;\n        gap: 178px;\n    }\n    div.selectbank div.allbanks div.Banks div.singlebank {\n        width: 98px !important;\n    }\n    div.otpcontainer div.otp div.inp input {\n        width: 47px !important;\n        height: 48px !important;\n    }\n\n    div.selectbank div.input input {\n        // width: 342px !important;\n    }\n\n   }\n\n@media screen and (max-width: 400px) {\n    body{\n        min-width: 300px;\n    }\n    div.bankstatement div.navbar p {\n        font-family: Assistant;\n        font-size: 27px;\n        font-weight: 700;\n        line-height: 30px;\n        letter-spacing: 0em;\n        text-align: left;\n        margin-top: 3%;\n        margin-right: min(4vw, 80px);\n      }\n\n      div.bankstatement div.mybody div.upload_container p {\n        font-family: Assistant;\n        font-size: 12px !important;\n    }\ndiv.bankstatement div.mybody div.statement div.option p {\n  font-size: 0.5rem;\n\n  margin-left: 5px;\n\n}\ndiv.process div.regulation p {\n    \n    font-size: 2.72vw;\n   \n  }\n  div.process div.steps p span {\n  \n    font-size: 0.6rem;\n \n  }\n  div.process div.content p {\n   \n    font-size: 0.7rem;\n   \n  }\n  div.otppanel div.inp input {\n    width: 9vw !important;\n   \n  }\n  div.otppanel div.inp div.resend .re {\n   \n    font-size: 4vw !important;\n    \n  }\n  div.otppanel div.inp div.resend .time {\n    font-size: 5vw !important;\n  }\n  div.otppanel .warning {\n    font-size: 5vw !important;\n  }\n  div.otppanel .terms {\n    font-size: 4vw !important;\n  }\n\n  div.verifyotp div.mybody div.otppanel {\n  \n    width: 78vw !important;\n    \n    .finvu{\n        font-size: 3.5vw !important;\n    }\n  }\n  div.verifyotp div.bank{\n    img{\n        height: 28px !important;\n        margin-top: 11px;\n    }\n    .finvologo{\n        height: 42px !important;\n        margin-top: 0px;\n    }\n  }\n\n  div.selectbank div.input div.othersbank div.banks span {\n    font-size: 5vw !important;\n  \n  }\n\n\n  div.verifyotp div.mybody div.otppanel button {\n    width: 60vw !important;\n  }\n\n//   div.jointlogo img {\n//     width: 73px !important;\n//     height: 37px !important;\n//   }\n\n  div.selectbank div.input div.Banks div.singlebank {\n    width: 25vw !important;\n    height: 97px !important;\n  }\n  div.selectbank div.input div.Banks div.singlebank p {\n    font-size: 11px !important;\n  }\n  div.linkaccount div.footer p{\n    // font-size: 4vw !important;\n  }\n  div.verifyotp div.mybody div.footer {\n   font-size: 4vw !important;\n  }\n\n  div.confirmconsent .consentDetail {\n    // margin-top: 31% !important;\n    margin-left: 1% !important;\n  }\n\n\n\ndiv.confirmconsent .consentDetail h1 {\n  font-family: Assistant;\n  font-size: 1.2rem !important;\n\n}\ndiv.confirmconsent .consentDetail .consentform .field {\n    font-family: Assistant;\n    font-size: 18px !important;\n  }\n  div.confirmconsent .consentDetail .consentform .value {\n    font-family: Assistant;\n    font-size: 16px !important;\n  }\n  div.selectbank div.input input {\n    height: 58px !important;\n    width: 85vw !important;\n  }\n  div.confirmconsent .consentDetail .consentform .date {\n    display: flex !important;\n    gap: 25vw !important;\n    justify-content: left;\n  }\n\ndiv.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .name {\n  font-family: Assistant;\n  font-size: 16px !important;\n  max-width: 89px;\n}\ndiv.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .account {\n    font-family: Assistant;\n    font-size: 18px !important;\n  }\n  div.confirmconsent .consentDetail .consentform div.bank_account div.bank div.information .type {\n    font-family: Assistant;\n    font-size: 16px !important;\n  }\n  div.confirmconsent .consentDetail .consentform div.bank_account div.bank input {\n    // margin-left: 6vw !important;\n\n  }\n  div.navbarcomponent h1 {\n    // font-size: 9vw !important;\n  }\ndiv.verifyotp div.navbar {\n  width: 100vw !important;\n}\ndiv.confirmconsent .consentDetail .consentform div.bank_account div.bank {\n    width: 83vw !important;\n  }\ndiv.verifyotp div.navbar p {\n    font-family: Assistant;\n    font-size: 8vw;\n    font-weight: 700;\n    line-height: 30px;\n    letter-spacing: 0em;\n    text-align: left;\n    margin-right: 29%;\n    margin-top: 11px;\n  }\n\n  div.bankstatement div.mybody div.upload_container div.submitbtn button p {\n    font-family: Assistant;\n    font-size: 13px !important;\n  }\n  div.bankstatement div.mybody div.upload_container div.submitbtn button img {\n    height: 23px;\n  }\n  div.linkaccount div.content div.bank_account div.bank div.information .name {\n    font-family: Assistant;\n    font-size: 16px !important;\n    width: 51vw;\n  }\n\n\ndiv.linkaccount div.content div.bank_account div.bank div.information .account {\n  font-family: Assistant;\n//   font-size: 6vw !important;\n}\n\n\ndiv.linkaccount div.content div.bank_account div.bank div.information .type {\n  font-family: Assistant;\n  font-size: 15px !important;\n}\ndiv.linkaccount div.content div.bank_account div.bank input {\n    margin-left: 8vw !important;\n  }\n  div.navbarcomponent {\n    // padding: 8% !important;\n    width: 100vw;\n  }\n\n  div.linkaccount div.content div.bank_account div.bank {\n    width: 87vw !important;\n  }\n  div.linkaccount div.content p{\n    // font-size: 5vw;\n  }\n\n\n  div.otp div.inp div.resend button {\n    width: 59vw !important;\n  }\n  div.verifyotp div.mybody div.otppanel div.inp p {\n    font-family: Assistant;\n    font-size: 14px !important;\n\n}\ndiv.bankstatement div.mybody div.text {\n    display: flex;\n    gap: 16px;\n    background-color: rgba(21, 39, 69, 0.031372549);\n    color: rgba(21, 39, 69, 0.5019607843);\n    margin-top: 10%;\n    padding: 2%;\n    border-radius: 10px;\n    width: 285px;\n    align-content: center;\n    // margin-left: 45px;\n  }\n  div.bankstatement div.mybody div.text div.some_text p {\n    color: rgba(21, 39, 69, 0.5019607843);\n    font-weight: 600;\n    font-size: 11px;\n    margin-top: 0px;\n    width: 228px;\n  }\n  div.bankstatement div.mybody div.middlecontainer {\n    box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);\n    padding: 18px;\n    width: 285px;\n    height: 240px;\n    border-radius: 10px;\n  }\n  div.bankstatement div.mybody div.upload_container {\n    width: 285px;\n    margin-top: 1rem;\n    box-shadow: 0px 0px 4px 0px rgba(21, 39, 69, 0.2);\n    padding: 5%;\n    height: 232px;\n    border-radius: 10px;\n  }\n  div.bankstatement div.mybody div.upload_container div.submitbtn button p {\n    font-family: Assistant;\n    font-size: 17px !important;\n  }\n  div.bankstatement div.mybody div.statement div.option p {\n    font-size: 10px;\n    margin-left: 7px;\n  }\n  div.bankstatement div.mybody div.statement div.option span {\n    font-weight: 600;\n    color: #152745;\n    font-size: 0.7rem;\n  }\n  div.bankstatement div.mybody div.slider {\n    margin-top: 1rem;\n    display: flex;\n    align-items: center;\n    width: 285px;\n  }\n\n\n\n  div.process {\n\n    border-radius: 20px;\n\n    width: 87vw;\n    padding: 25px;\n    height: 455px;\n    margin-left: -6vw;\n  }\n  div.process div.content p {\n    font-size: 12px;\n  }\n  div.process div.steps p span {\n    font-size: 12px;\n  }\n  div.process div.proceed button {\n    border-radius: 10px;\n    gap: 10px;\n    background-color: #FC6603;\n    color: white;\n    font-family: Assistant;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 26px;\n    letter-spacing: 0em;\n    text-align: center;\n    border: none;\n    padding: 5%;\n    padding-inline: 15%;\n    width: 193px;\n    height: 54px;\n  }\n\n  div.verifyotp div.mybody div.otppanel div.inp div.resend {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 43px;\n    justify-content: center;\n    gap: 116px;\n}\ndiv.verifyotp div.mybody div.footer p {\n    font-size: 11px !important;\n}\ndiv.footer p {\n    font-size: 11px !important;\n}\ndiv.verifyotp div.mybody {\n    padding-inline: 0% !important;\n}\ndiv.otp div.inp input {\n    width: 34px !important;\n    height: 51px !important;\n}\ndiv.linkaccount div.content div.bank_account div.bank .checkedinput {\n    margin-left: 8vw !important;\n}\n }\n\n .underreviewresults{\n    padding-inline: 16px;\n\n    .loadingimages{\n        text-align:center ;\n        img{\n            height: 345px;\n            margin-top: 15px;\n            width: 343px;\n        }\n        .review-text{\n            color: #152745;            ;\n            font-family: Assistant;\n            font-size: 40px;\n            font-weight: 700;\n            line-height: 52.32px;\n            text-align: center;\n            text-underline-position: from-font;\n            text-decoration-skip-ink: none;\n            margin-top: 36px;\n\n        }\n        .review-message{\n            font-family: Assistant;\nfont-size: 18px;\nfont-weight: 400;\nline-height: 23.54px;\ntext-align: center;\ntext-underline-position: from-font;\ntext-decoration-skip-ink: none;\n\n        }\n        button{\n           width: 240px;\n           height: 60px;\n       gap: 10px;\n      border-radius: 10px ;\nopacity: 0px;\nborder: none;\nbackground-color: #FC6603;\ncolor: #FFFFFF;\nfont-size: 20px;\nfont-weight: 600;\nmargin-top: 200px;\nposition: relative;\nbottom: 40px;\n\n        }\n    }\n  }\n @media screen and (max-width: 400px){\n\n     div.otp div.inp input {\n        width: 37px !important;\n        height: 49px !important;\n        \n        }\n\n        div.confirmconsent .consentDetail .consentform div.bank_account div.bank input {\n            margin-left: 30vw !important;\n          \n        }\n        div.confirmconsent .consentDetail .consentform div.submit button {\n            border: none;\n            width: 260px;\n            height: 60px;\n            background-color: #FC6603;\n            border-radius: 10px;\n            font-size: 1.3rem;\n            font-weight: 600;\n            line-height: 26px;\n            letter-spacing: 0em;\n            text-align: center;\n            color: #FFFFFF;\n        }\n\n        div.jointlogo {\n         \n            gap: 64px !important;\n         \n        }\n\n        div.otpcontainer div.otp div.inp input {\n            width: 12vw !important;\n            height: 12vw !important;\n        }\n        div.verifyotp div.mybody div.otppanel div.inp input {\n            width: 11vw !important;\n            height: 11.6vw !important;\n        }\n        div.selectbank div.allbanks div.Banks div.singlebank {\n            width: 24vw !important;\n            height: 98px !important;\n        }\n        div.selectbank div.allbanks div.othersbank div.banks hr {\n            width: 84vw !important;\n        }\n\n        div.selectbank div.allbanks div.Banks div.singlebank p {\n          \n            font-size: 13px !important;\n            \n        }\n        div.selectbank div.allbanks {\n            max-width: 335px !important;\n        }\n    }\n    @media screen and (max-width: 387px)\n    {\n        div.otp div.inp p {\n            font-family: Assistant;\n            font-size: 15px;\n            font-weight: 400;\n            line-height: 24px;\n            letter-spacing: 0em;\n        }\n        div.selectbank div.allbanks div.Banks div.singlebank {\n            width: 24.2vw !important;\n            height: 97px !important;\n        }\n    }\n    @media screen  and (max-width:390px){\n        div.selectbank div.allbanks {\n            max-width: 327px !important;\n        }\n        \n    }\n    @media screen and (max-width:383px) {\n\n        div.selectbank div.allbanks div.Banks {\n            margin-top: 1rem;\n            display: flex;\n            flex-wrap: wrap;\n            gap: 4%;\n        }\n\n        div.selectbank div.input input {\n            height: 58px !important;\n            width: 80vw !important;\n        }\n\n        div.selectbank div.allbanks {\n            max-width: 311px !important;\n        }\n        \n    }\n    @media screen and (max-width:375px) {\n        div.otp div.inp p {\n            font-family: Assistant;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 24px;\n            letter-spacing: 0em;\n        }\n        div.selectbank div.allbanks{\n            max-width: 300px !important;\n        }\n        div.selectbank div.allbanks div.Banks {\n            margin-top: 1rem;\n            display: flex;\n            flex-wrap: wrap;\n            gap: 3%;\n        }\n    }\n    @media screen and (max-width: 361px)\n    {\ndiv.confirmconsent .consentDetail .consentform div.bank_account div.bank input {\n    margin-left: 25vw !important;\n}\ndiv.otp div.inp input {\n    width: 10vw !important;\n    height: 44px !important;\n}\n\ndiv.otpcontainer div.otp div.inp input {\n    width: 11vw !important;\n    height: 11vw !important;\n}\n\n    }\n\n    @media screen and (max-width: 374px){\n    div.verifyotp div.mybody div.otppanel div.inp input {\n        width: 37px !important;\n        height: 50px !important;\n    }\n\n    }\n\n    @media screen and (max-width: 374px){\n        div.verifyotp div.mybody div.otppanel div.inp input {\n            width: 11.5vw !important;\n            height: 12.6vw !important;\n        }\n        div.linkaccount div.content div.bank_account div.bank div.information .name {\n            font-family: Assistant;\n            font-size: 16px !important;\n            width: 45vw !important;\n        }\n       \n    \n        }\n@media screen and (max-width:375px){\n    div.selectbank div.allbanks div.Banks div.singlebank {\n        width: 24.6vw !important;\n        height: 100px !important;\n    }\n    \n}\n    @media screen and (max-width: 365px){\n    div.process {\n        border-radius: 20px;\n        width: 87vw;\n        padding: 25px;\n        height: 455px;\n        margin-left: -4vw;\n    }\n   \n}\n\n@media screen and (max-width: 362px){\n    div.selectbank div.allbanks div.Banks div.singlebank {\n        width: 24.6vw !important;\n        height: 101px !important;\n    }\n\n    }\n\n    @media screen and (max-width: 355px){\ndiv.linkaccount div.content div.bank_account div.bank .checkedinput {\n    margin-left: 8vw !important;\n}\ndiv.verifyotp div.mybody div.otppanel div.inp input {\n    // width: 32px !important;\n    // height: 41px !important;\n}\ndiv.linkaccount div.content div.bank_account div.bank {\n    width: 84vw !important;\n}\n\ndiv.linkaccount div.content div.bank_account div.bank div.information .name {\n    font-family: Assistant;\n    font-size: 16px !important;\n    width: 49vw;\n}\ndiv.selectbank div.allbanks div.Banks div.singlebank {\n    width: 24vw !important;\n    height: 101px !important;\n}\ndiv.selectbank div.allbanks div.Banks div.singlebank p {\n    font-size: 12px !important;\n}\ndiv.selectbank div.allbanks {\n    max-width: 282px !important;\n}\n    }\n\n\n    @media screen and (max-width: 346px)\n    {\ndiv.linkaccount div.content div.bank_account div.bank div.information .name {\n    font-family: Assistant;\n    font-size: 15px !important;\n}\ndiv.jointlogo {\n    gap: 20vw !important;\n}\ndiv.selectbank div.allbanks div.Banks div.singlebank {\n    width: 24vw !important;\n    height: 101px !important;\n}\ndiv.selectbank div.input input {\n    height: 58px !important;\n    width: 81vw !important;\n}\ndiv.verifyotp div.mybody div.otppanel div.inp div.resend {\n   \n    gap: 94px !important;\n}\n    }\n    @media screen and (max-width: 342px){\ndiv.process {\n    border-radius: 20px;\n    width: 87vw;\n    padding: 25px;\n    height: 455px;\n    margin-left: -1vw;\n}\ndiv.selectbank div.allbanks {\n    max-width: 265px !important;\n}\n    }\n    @media screen and (max-width: 332px)\n    {\ndiv.linkaccount div.content div.bank_account div.bank div.information .name {\n    font-family: Assistant;\n    // font-size: 14px !important;\n}\ndiv.selectbank div.allbanks div.Banks div.singlebank {\n    width: 24vw !important;\n    height: 96px !important;\n}\ndiv.selectbank div.allbanks div.Banks div.singlebank p {\n    margin-top: 5px !important;\n}\n    }\n\n\n    @media screen and (max-width: 326px){\n        div.verifyotp div.mybody div.otppanel div.inp input {\n            // width: 31px !important;\n            // height: 44px !important;\n        }\n    \n        }\n\n    @media screen and (max-width: 324px){\n        div.process {\n            \n            margin-left: 1vw;\n        }\n            }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
